/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 21);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint max-len: 0 */

var ConfigScene = {
  // fonts
  FONT_BASE: 'advent',

  SIZES: {
    SCENE_WIDTH_MAX: 1420,
    SCENE_CONT_HEIGHT: 3000,
    SCENE_ACTIVE_HEIGHT: 680
  },

  TOWN_SCALE_DIFF: [0.2, 0.3, 0.4, 0.45],

  // parallax
  DIFF_X: 50,
  DIFF_Y: 30,

  MOVE_DIFF_SKY: {
    X: 30,
    Y: 18
  },

  MOVE_DIFF_ITEMS: [[15, 9], [10, 6], [0, 0], [-5, -2]],

  MOVE_DIFF_BULLETS: [[10, 6], [5, 3], [-5, -2.5], [-10, -5]],

  // items call types
  E_ITEM_HOVER: 'eventItemHover',
  E_ITEM_BULLET_SWITCH: 'eventItemBulletSwitch', // show/hide help-mode bubble
  E_INFO_BLL_SHOW: 'eventInfoBubbleShow',
  E_INFO_BLL_HIDE: 'eventInfoBubbleHide',

  // table
  TABLE_TILE_MAX_STEPS: 4,

  // init vars
  INIT_POS_X: 0.5,
  INIT_POS_Y: 0.5,

  TOWN_LAYERS: [[{
    bm: 'lr-0-0',
    x: 225,
    y: 56
  }, {
    bm: 'lr-0-1',
    x: 580,
    y: 80
  }], [{
    bm: 'lr-1-0',
    x: 120,
    y: 30
  }], [{
    bm: 'lr-2-1',
    x: 252,
    y: 492
  }, {
    bm: 'lr-2-0',
    x: 0,
    y: -197
  }, {
    bm: 'lr-2-2',
    x: 909,
    y: -211
  }], []],

  TOWN_SNOW_OVER: [[{
    bm: 'sn-2',
    x: 293,
    y: 61
  }], [{
    bm: 'sn-1',
    x: 130,
    y: 29
  }], [{
    bm: 'sn-0-b-0',
    x: -2,
    y: 50
  }, {
    bm: 'sn-0-b-1',
    x: 112,
    y: 520
  }, {
    bm: 'sn-0-b-2',
    x: 943,
    y: -215
  }, {
    bm: 'sn-0-f-0',
    x: 190,
    y: 193
  }, {
    bm: 'sn-0-f-1',
    x: 1173,
    y: 402
  }], []]
};

var ANGELS = exports.ANGELS = {
  a0: {
    snow: {
      x: 9,
      y: 118,
      w: 135,
      delay: 1200
    },
    parts: ['a_0_cl_0.png', 'a_0_cl_1.png', 'a_0_cl_2.png', 'a_0_ch_0.png', 'a_0_ch_1.png', 'a_0_ch_2.png', 'a_0_ch_3.png'],
    anim: { a_0_cl_0: [[1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [1, 2, 94], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 2, 100], [1, 2, 97.7], [1, 2, 96], [1, 2, 94.7], [1, 2, 94]], a_0_ch_1: [[0], [1, 27, 33], [1, 27, 33], [1, 27, 33], [1, 27, 33], [1, 27, 33], [1, 27, 33], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0]], a_0_cl_2: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 8, 28], [1, 8, 31.8], [1, 8, 34.8], [1, 8, 37.2], [1, 8, 39], [1, 8, 40], [1, 8, 39.5], [1, 8, 38.1], [1, 8, 35.7], [1, 8, 32.3], [1, 8, 28], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 8, 28], [1, 8, 31.8], [1, 8, 34.8], [1, 8, 37.2], [1, 8, 39], [1, 8, 40], [1, 8, 39.5], [1, 8, 38.1], [1, 8, 35.7], [1, 8, 32.3], [1, 8, 28], [0], [0], [0], [0], [0]], a_0_ch_3: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 31, 18], [1, 31, 13.3], [1, 31, 9.5], [1, 31, 6.5], [1, 31, 4.3], [1, 31, 3], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 31, 18], [1, 31, 13.3], [1, 31, 9.5], [1, 31, 6.5], [1, 31, 4.3], [1, 31, 3], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0]], a_0_ch_0: [[1, 29, 28], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 29, 34], [1, 29, 31.7], [1, 29, 30], [1, 29, 28.7], [1, 29, 28]], a_0_cl_1: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 9, 25], [1, 9, 27.8], [1, 9, 30.1], [1, 9, 31.9], [1, 9, 33.2], [1, 9, 34], [1, 9, 33.7], [1, 9, 32.6], [1, 9, 30.8], [1, 9, 28.3], [1, 9, 25], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 9, 25], [1, 9, 27.8], [1, 9, 30.1], [1, 9, 31.9], [1, 9, 33.2], [1, 9, 34], [1, 9, 33.7], [1, 9, 32.6], [1, 9, 30.8], [1, 9, 28.3], [1, 9, 25], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0]], a_0_ch_2: [[0], [0], [0], [0], [0], [0], [0], [1, 28, 15], [1, 28, 11.6], [1, 28, 8.7], [1, 28, 6.3], [1, 28, 4.3], [1, 28, 2.9], [1, 28, 2], [1, 28, 2.4], [1, 28, 3.5], [1, 28, 5.3], [1, 28, 7.8], [1, 28, 11.1], [1, 28, 15], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 30, 5], [1, 30, 5.5], [1, 30, 6.8], [1, 30, 9], [1, 30, 12.1], [1, 30, 16.1], [1, 30, 21], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 28, 15], [1, 28, 11.6], [1, 28, 8.7], [1, 28, 6.3], [1, 28, 4.3], [1, 28, 2.9], [1, 28, 2], [1, 28, 2.4], [1, 28, 3.5], [1, 28, 5.3], [1, 28, 7.8], [1, 28, 11.1], [1, 28, 15], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 30, 5], [1, 30, 5.5], [1, 30, 6.8], [1, 30, 9], [1, 30, 12.1], [1, 30, 16.1], [1, 30, 21], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0]] }
  },
  a1: {
    snow: {
      x: 15,
      y: 203,
      w: 205,
      delay: 1200
    },
    parts: ['a_1_cl_0.png', 'a_1_cl_1.png', 'a_1_ch_0.png', 'a_1_ch_1.png', 'a_1_ch_2.png'],
    anim: { a_1_cl_1: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 2, 81], [1, 2, 87.8], [1, 2, 94], [1, 2, 99.5], [1, 2, 104.3], [1, 2, 108.5], [1, 2, 112.1], [1, 2, 115], [1, 2, 114.1], [1, 2, 113.5], [1, 2, 113.1], [1, 2, 113], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 2, 81], [1, 2, 87.8], [1, 2, 94], [1, 2, 99.5], [1, 2, 104.3], [1, 2, 108.5], [1, 2, 112.1], [1, 2, 115], [1, 2, 114.1], [1, 2, 113.5], [1, 2, 113.1], [1, 2, 113], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 2, 81], [1, 2, 87.8], [1, 2, 94], [1, 2, 99.5], [1, 2, 104.3], [1, 2, 108.5], [1, 2, 112.1], [1, 2, 115], [1, 2, 114.1], [1, 2, 113.5], [1, 2, 113.1], [1, 2, 113], [0], [0], [0], [0], [0], [0], [0]], a_1_ch_0: [[1, 68, 78], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 68, 109], [1, 68, 101.7], [1, 68, 95.2], [1, 68, 89.7], [1, 68, 84.9], [1, 68, 81], [1, 68, 78]], a_1_ch_1: [[0], [1, 56, 84], [1, 56, 84], [1, 56, 84], [1, 56, 84], [1, 56, 84], [1, 56, 84], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0]], a_1_ch_2: [[0], [0], [0], [0], [0], [0], [0], [1, 64, 45], [1, 64, 37.3], [1, 64, 30.3], [1, 64, 24.1], [1, 64, 18.7], [1, 64, 14], [1, 64, 10.1], [1, 64, 6.9], [1, 64, 4.5], [1, 64, 5], [1, 64, 6.3], [1, 64, 8.5], [1, 64, 11.5], [1, 64, 15.5], [1, 64, 20.3], [1, 64, 26], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 64, 45], [1, 64, 37.3], [1, 64, 30.3], [1, 64, 24.1], [1, 64, 18.7], [1, 64, 14], [1, 64, 10.1], [1, 64, 6.9], [1, 64, 4.5], [1, 64, 5], [1, 64, 6.3], [1, 64, 8.5], [1, 64, 11.5], [1, 64, 15.5], [1, 64, 20.3], [1, 64, 26], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 64, 45], [1, 64, 37.3], [1, 64, 30.3], [1, 64, 24.1], [1, 64, 18.7], [1, 64, 14], [1, 64, 10.1], [1, 64, 6.9], [1, 64, 4.5], [1, 64, 5], [1, 64, 6.3], [1, 64, 8.5], [1, 64, 11.5], [1, 64, 15.5], [1, 64, 20.3], [1, 64, 26], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0]], a_1_cl_0: [[1, 4, 153], [1, 4, 153], [1, 4, 153], [1, 4, 153], [1, 4, 153], [1, 4, 153], [1, 4, 153], [1, 4, 153], [1, 4, 151.8], [1, 4, 150.6], [1, 4, 149.1], [1, 4, 147.6], [1, 4, 146], [1, 4, 144.2], [1, 4, 142.3], [1, 4, 140.3], [1, 4, 138.2], [1, 4, 136], [1, 4, 133.6], [1, 4, 131.1], [1, 4, 128.6], [1, 4, 125.8], [1, 4, 123], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 4, 153], [1, 4, 151.8], [1, 4, 150.6], [1, 4, 149.1], [1, 4, 147.6], [1, 4, 146], [1, 4, 144.2], [1, 4, 142.3], [1, 4, 140.3], [1, 4, 138.2], [1, 4, 136], [1, 4, 133.6], [1, 4, 131.1], [1, 4, 128.6], [1, 4, 125.8], [1, 4, 123], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 4, 153], [1, 4, 151.8], [1, 4, 150.6], [1, 4, 149.1], [1, 4, 147.6], [1, 4, 146], [1, 4, 144.2], [1, 4, 142.3], [1, 4, 140.3], [1, 4, 138.2], [1, 4, 136], [1, 4, 133.6], [1, 4, 131.1], [1, 4, 128.6], [1, 4, 125.8], [1, 4, 123], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 4, 184], [1, 4, 176.7], [1, 4, 170.2], [1, 4, 164.7], [1, 4, 159.9], [1, 4, 156], [1, 4, 153]] }
  },
  a2: {
    snow: {
      x: 11,
      y: 110,
      w: 120,
      delay: 1200
    },
    parts: ['a_2_cl_0.png', 'a_2_cl_1.png', 'a_2_ch_0.png', 'a_2_ch_1.png', 'a_2_ch_2.png'],
    anim: { a_2_ch_1: [[0], [1, 37, 53], [1, 37, 53], [1, 37, 53], [1, 37, 53], [1, 37, 53], [1, 37, 53], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0]], a_2_ch_2: [[0], [0], [0], [0], [0], [0], [0], [1, 36, 23], [1, 36, 18.8], [1, 36, 15], [1, 36, 11.7], [1, 36, 8.9], [1, 36, 6.5], [1, 36, 4.5], [1, 36, 3], [1, 36, 2], [1, 36, 2.5], [1, 36, 3.9], [1, 36, 6.3], [1, 36, 9.6], [1, 36, 13.8], [1, 36, 19], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 36, 23], [1, 36, 18.8], [1, 36, 15], [1, 36, 11.7], [1, 36, 8.9], [1, 36, 6.5], [1, 36, 4.5], [1, 36, 3], [1, 36, 2], [1, 36, 2.5], [1, 36, 3.9], [1, 36, 6.3], [1, 36, 9.6], [1, 36, 13.8], [1, 36, 19], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 36, 23], [1, 36, 18.8], [1, 36, 15], [1, 36, 11.7], [1, 36, 8.9], [1, 36, 6.5], [1, 36, 4.5], [1, 36, 3], [1, 36, 2], [1, 36, 2.5], [1, 36, 3.9], [1, 36, 6.3], [1, 36, 9.6], [1, 36, 13.8], [1, 36, 19], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0]], a_2_cl_0: [[1, 1, 82], [1, 1, 82], [1, 1, 82], [1, 1, 82], [1, 1, 82], [1, 1, 82], [1, 1, 82], [1, 1, 82], [1, 1, 81.4], [1, 1, 80.7], [1, 1, 79.9], [1, 1, 79.1], [1, 1, 78.1], [1, 1, 77.1], [1, 1, 76], [1, 1, 74.8], [1, 1, 73.6], [1, 1, 72.2], [1, 1, 70.8], [1, 1, 69.3], [1, 1, 67.7], [1, 1, 66], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 1, 82], [1, 1, 81.4], [1, 1, 80.7], [1, 1, 79.9], [1, 1, 79.1], [1, 1, 78.1], [1, 1, 77.1], [1, 1, 76], [1, 1, 74.8], [1, 1, 73.6], [1, 1, 72.2], [1, 1, 70.8], [1, 1, 69.3], [1, 1, 67.7], [1, 1, 66], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 1, 82], [1, 1, 81.4], [1, 1, 80.7], [1, 1, 79.9], [1, 1, 79.1], [1, 1, 78.1], [1, 1, 77.1], [1, 1, 76], [1, 1, 74.8], [1, 1, 73.6], [1, 1, 72.2], [1, 1, 70.8], [1, 1, 69.3], [1, 1, 67.7], [1, 1, 66], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 1, 98], [1, 1, 94.2], [1, 1, 90.9], [1, 1, 88], [1, 1, 85.6], [1, 1, 83.6], [1, 1, 82]], a_2_cl_1: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 2, 48], [1, 2, 54.3], [1, 2, 59.8], [1, 2, 64.5], [1, 2, 68.4], [1, 2, 71.6], [1, 2, 73.9], [1, 2, 75.5], [1, 2, 74.9], [1, 2, 73.1], [1, 2, 70.2], [1, 2, 66], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 2, 48], [1, 2, 54.3], [1, 2, 59.8], [1, 2, 64.5], [1, 2, 68.4], [1, 2, 71.6], [1, 2, 73.9], [1, 2, 75.5], [1, 2, 74.9], [1, 2, 73.1], [1, 2, 70.2], [1, 2, 66], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 2, 48], [1, 2, 54.3], [1, 2, 59.8], [1, 2, 64.5], [1, 2, 68.4], [1, 2, 71.6], [1, 2, 73.9], [1, 2, 75.5], [1, 2, 74.9], [1, 2, 73.1], [1, 2, 70.2], [1, 2, 66], [0], [0], [0], [0], [0], [0], [0]], a_2_ch_0: [[1, 30, 49], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 30, 65], [1, 30, 61.2], [1, 30, 57.9], [1, 30, 55], [1, 30, 52.6], [1, 30, 50.6], [1, 30, 49]] }
  },
  a3: {
    snow: {
      x: 16,
      y: 204,
      w: 202,
      delay: 1200
    },
    parts: ['a_3_cl_0.png', 'a_3_cl_1.png', 'a_3_ch_0.png', 'a_3_ch_1.png', 'a_3_ch_2.png'],
    anim: { a_3_cl_0: [[1, 6, 164], [1, 6, 164], [1, 6, 164], [1, 6, 164], [1, 6, 164], [1, 6, 164], [1, 6, 164], [1, 6, 164], [1, 6, 161.2], [1, 6, 158.5], [1, 6, 156.1], [1, 6, 153.7], [1, 6, 151.6], [1, 6, 149.6], [1, 6, 147.8], [1, 6, 146.2], [1, 6, 144.7], [1, 6, 143.5], [1, 6, 142.3], [1, 6, 141.4], [1, 6, 140.6], [1, 6, 140], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 6, 164], [1, 6, 161.2], [1, 6, 158.5], [1, 6, 156.1], [1, 6, 153.7], [1, 6, 151.6], [1, 6, 149.6], [1, 6, 147.8], [1, 6, 146.2], [1, 6, 144.7], [1, 6, 143.5], [1, 6, 142.3], [1, 6, 141.4], [1, 6, 140.6], [1, 6, 140], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 6, 164], [1, 6, 161.2], [1, 6, 158.5], [1, 6, 156.1], [1, 6, 153.7], [1, 6, 151.6], [1, 6, 149.6], [1, 6, 147.8], [1, 6, 146.2], [1, 6, 144.7], [1, 6, 143.5], [1, 6, 142.3], [1, 6, 141.4], [1, 6, 140.6], [1, 6, 140], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 6, 186], [1, 6, 180.8], [1, 6, 176.2], [1, 6, 172.3], [1, 6, 168.9], [1, 6, 166.2], [1, 6, 164]], a_3_cl_1: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 0, 49], [1, 0, 57.5], [1, 0, 64.8], [1, 0, 71.2], [1, 0, 76.4], [1, 0, 80.7], [1, 0, 83.8], [1, 0, 85.9], [1, 0, 85.2], [1, 0, 83], [1, 0, 79.2], [1, 0, 74], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 0, 49], [1, 0, 57.5], [1, 0, 64.8], [1, 0, 71.2], [1, 0, 76.4], [1, 0, 80.7], [1, 0, 83.8], [1, 0, 85.9], [1, 0, 85.2], [1, 0, 83], [1, 0, 79.2], [1, 0, 74], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 0, 49], [1, 0, 57.5], [1, 0, 64.8], [1, 0, 71.2], [1, 0, 76.4], [1, 0, 80.7], [1, 0, 83.8], [1, 0, 85.9], [1, 0, 85.2], [1, 0, 83], [1, 0, 79.2], [1, 0, 74], [0], [0], [0], [0], [0], [0], [0]], a_3_ch_0: [[1, 72, 41], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 72, 63], [1, 72, 57.8], [1, 72, 53.2], [1, 72, 49.3], [1, 72, 45.9], [1, 72, 43.2], [1, 72, 41]], a_3_ch_1: [[0], [1, 51, 60], [1, 51, 60], [1, 51, 60], [1, 51, 60], [1, 51, 60], [1, 51, 60], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0]], a_3_ch_2: [[0], [0], [0], [0], [0], [0], [0], [1, 55, 33], [1, 55, 27.2], [1, 55, 22], [1, 55, 17.4], [1, 55, 13.5], [1, 55, 10.1], [1, 55, 7.5], [1, 55, 5.4], [1, 55, 4], [1, 55, 4.8], [1, 55, 7.2], [1, 55, 11.3], [1, 55, 16.9], [1, 55, 24.2], [1, 55, 33], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 55, 33], [1, 55, 27.2], [1, 55, 22], [1, 55, 17.4], [1, 55, 13.5], [1, 55, 10.1], [1, 55, 7.5], [1, 55, 5.4], [1, 55, 4], [1, 55, 4.8], [1, 55, 7.2], [1, 55, 11.3], [1, 55, 16.9], [1, 55, 24.2], [1, 55, 33], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 55, 33], [1, 55, 27.2], [1, 55, 22], [1, 55, 17.4], [1, 55, 13.5], [1, 55, 10.1], [1, 55, 7.5], [1, 55, 5.4], [1, 55, 4], [1, 55, 4.8], [1, 55, 7.2], [1, 55, 11.3], [1, 55, 16.9], [1, 55, 24.2], [1, 55, 33], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0]] }
  },
  a4: {
    snow: {
      x: 15,
      y: 168,
      w: 326,
      delay: 1200
    },
    parts: ['a_4_cl_0.png', 'a_4_cl_1.png', 'a_4_ch_0.png', 'a_4_ch_1.png', 'a_4_ch_2.png', 'a_4_ch_3.png'],
    anim: { a_4_cl_0: [[1, 3, 82], [1, 3, 82], [1, 3, 82], [1, 3, 82], [1, 3, 82], [1, 3, 82], [1, 3, 82], [1, 3, 82], [1, 3, 83.8], [1, 3, 85.1], [1, 3, 86], [1, 3, 85.4], [1, 3, 84.6], [1, 3, 83.8], [1, 3, 82.8], [1, 3, 81.7], [1, 3, 80.5], [1, 3, 79.3], [1, 3, 77.9], [1, 3, 76.4], [1, 3, 74.7], [1, 3, 73], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 3, 82], [1, 3, 83.8], [1, 3, 85.1], [1, 3, 86], [1, 3, 85.4], [1, 3, 84.6], [1, 3, 83.8], [1, 3, 82.8], [1, 3, 81.7], [1, 3, 80.5], [1, 3, 79.3], [1, 3, 77.9], [1, 3, 76.4], [1, 3, 74.7], [1, 3, 73], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 3, 82], [1, 3, 83.8], [1, 3, 85.1], [1, 3, 86], [1, 3, 85.4], [1, 3, 84.6], [1, 3, 83.8], [1, 3, 82.8], [1, 3, 81.7], [1, 3, 80.5], [1, 3, 79.3], [1, 3, 77.9], [1, 3, 76.4], [1, 3, 74.7], [1, 3, 73], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 3, 103], [1, 3, 98.1], [1, 3, 93.7], [1, 3, 89.9], [1, 3, 86.7], [1, 3, 84.1], [1, 3, 82]], a_4_ch_2: [[0], [0], [0], [0], [0], [0], [0], [1, 59, 28], [1, 59, 22.3], [1, 59, 17.3], [1, 59, 13], [1, 59, 9.5], [1, 59, 6.6], [1, 59, 4.5], [1, 59, 3], [1, 59, 5.1], [1, 59, 7.6], [1, 59, 10.7], [1, 59, 14.3], [1, 59, 18.3], [1, 59, 22.9], [1, 59, 28], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 59, 28], [1, 59, 22.3], [1, 59, 17.3], [1, 59, 13], [1, 59, 9.5], [1, 59, 6.6], [1, 59, 4.5], [1, 59, 3], [1, 59, 5.1], [1, 59, 7.6], [1, 59, 10.7], [1, 59, 14.3], [1, 59, 18.3], [1, 59, 22.9], [1, 59, 28], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 59, 28], [1, 59, 22.3], [1, 59, 17.3], [1, 59, 13], [1, 59, 9.5], [1, 59, 6.6], [1, 59, 4.5], [1, 59, 3], [1, 59, 5.1], [1, 59, 7.6], [1, 59, 10.7], [1, 59, 14.3], [1, 59, 18.3], [1, 59, 22.9], [1, 59, 28], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0]], a_4_ch_0: [[1, 61, 33], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 61, 54], [1, 61, 49.1], [1, 61, 44.7], [1, 61, 40.9], [1, 61, 37.7], [1, 61, 35.1], [1, 61, 33]], a_4_ch_1: [[0], [1, 53, 40], [1, 53, 40], [1, 53, 40], [1, 53, 40], [1, 53, 40], [1, 53, 40], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0]], a_4_cl_1: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 0, 45], [1, 0, 50.9], [1, 0, 56.3], [1, 0, 61], [1, 0, 65.1], [1, 0, 68.7], [1, 0, 71.7], [1, 0, 74], [1, 0, 72.9], [1, 0, 71.4], [1, 0, 69.5], [1, 0, 67.4], [1, 0, 64.9], [1, 0, 62], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 0, 45], [1, 0, 50.9], [1, 0, 56.3], [1, 0, 61], [1, 0, 65.1], [1, 0, 68.7], [1, 0, 71.7], [1, 0, 74], [1, 0, 72.9], [1, 0, 71.4], [1, 0, 69.5], [1, 0, 67.4], [1, 0, 64.9], [1, 0, 62], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 0, 45], [1, 0, 50.9], [1, 0, 56.3], [1, 0, 61], [1, 0, 65.1], [1, 0, 68.7], [1, 0, 71.7], [1, 0, 74], [1, 0, 72.9], [1, 0, 71.4], [1, 0, 69.5], [1, 0, 67.4], [1, 0, 64.9], [1, 0, 62], [0], [0], [0], [0], [0], [0], [0]], a_4_ch_3: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 159.1, 77.6], [1, 159.1, 75.4], [1, 159.1, 73.5], [1, 159.1, 72], [1, 159.1, 70.8], [1, 159.1, 70], [1, 159.1, 69.5], [1, 159.1, 69.3], [1, 159.1, 71], [1, 159.1, 73.6], [1, 159.1, 77.2], [1, 159.1, 81.7], [1, 159.1, 87.2], [1, 159.1, 93.6], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 159.1, 77.6], [1, 159.1, 75.4], [1, 159.1, 73.5], [1, 159.1, 72], [1, 159.1, 70.8], [1, 159.1, 70], [1, 159.1, 69.5], [1, 159.1, 69.3], [1, 159.1, 71], [1, 159.1, 73.6], [1, 159.1, 77.2], [1, 159.1, 81.7], [1, 159.1, 87.2], [1, 159.1, 93.6], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 159.1, 77.6], [1, 159.1, 75.4], [1, 159.1, 73.5], [1, 159.1, 72], [1, 159.1, 70.8], [1, 159.1, 70], [1, 159.1, 69.5], [1, 159.1, 69.3], [1, 159.1, 71.1], [1, 159.1, 73.8], [1, 159.1, 77.5], [1, 159.1, 82.2], [1, 159.1, 87.9], [1, 159.1, 94.6], [0], [0], [0], [0], [0], [0], [0]] }
  },
  a5: {
    snow: {
      x: 12,
      y: 168,
      w: 155,
      delay: 1200
    },
    parts: ['a_5_cl_0.png', 'a_5_ch_0.png', 'a_5_ch_1.png', 'a_5_ch_2.png', 'a_5_ch_3.png'],
    anim: { a_5_ch_3: [[0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 5, 40], [1, 5, 47.6], [1, 5, 54.2], [1, 5, 59.8], [1, 5, 64.5], [1, 5, 68.3], [1, 5, 71.1], [1, 5, 73], [1, 5, 72.3], [1, 5, 70.3], [1, 5, 66.8], [1, 5, 62], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 5, 40], [1, 5, 47.6], [1, 5, 54.2], [1, 5, 59.8], [1, 5, 64.5], [1, 5, 68.3], [1, 5, 71.1], [1, 5, 73], [1, 5, 72.3], [1, 5, 70.3], [1, 5, 66.8], [1, 5, 62], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 5, 40], [1, 5, 47.6], [1, 5, 54.2], [1, 5, 59.8], [1, 5, 64.5], [1, 5, 68.3], [1, 5, 71.1], [1, 5, 73], [1, 5, 72.3], [1, 5, 70.3], [1, 5, 66.8], [1, 5, 62], [0], [0], [0], [0], [0], [0], [0]], a_5_cl_0: [[1, 4, 134], [1, 4, 134], [1, 4, 134], [1, 4, 134], [1, 4, 134], [1, 4, 134], [1, 4, 134], [1, 4, 134], [1, 4, 133.9], [1, 4, 133.5], [1, 4, 132.8], [1, 4, 131.9], [1, 4, 130.7], [1, 4, 129.2], [1, 4, 127.5], [1, 4, 125.5], [1, 4, 123.3], [1, 4, 120.8], [1, 4, 118], [1, 4, 114.9], [1, 4, 111.6], [1, 4, 108], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 4, 134], [1, 4, 133.9], [1, 4, 133.5], [1, 4, 132.8], [1, 4, 131.9], [1, 4, 130.7], [1, 4, 129.2], [1, 4, 127.5], [1, 4, 125.5], [1, 4, 123.3], [1, 4, 120.8], [1, 4, 118], [1, 4, 114.9], [1, 4, 111.6], [1, 4, 108], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 4, 134], [1, 4, 133.9], [1, 4, 133.5], [1, 4, 132.8], [1, 4, 131.9], [1, 4, 130.7], [1, 4, 129.2], [1, 4, 127.5], [1, 4, 125.5], [1, 4, 123.3], [1, 4, 120.8], [1, 4, 118], [1, 4, 114.9], [1, 4, 111.6], [1, 4, 108], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 4, 153], [1, 4, 148.5], [1, 4, 144.6], [1, 4, 141.2], [1, 4, 138.2], [1, 4, 135.9], [1, 4, 134]], a_5_ch_0: [[1, 49, 37], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 49, 57], [1, 49, 52.3], [1, 49, 48.1], [1, 49, 44.5], [1, 49, 41.5], [1, 49, 39], [1, 49, 37]], a_5_ch_1: [[0], [1, 50, 41], [1, 50, 41], [1, 50, 41], [1, 50, 41], [1, 50, 41], [1, 50, 41], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0]], a_5_ch_2: [[0], [0], [0], [0], [0], [0], [0], [1, 51, 29], [1, 51, 23.8], [1, 51, 19.2], [1, 51, 15.1], [1, 51, 11.6], [1, 51, 8.6], [1, 51, 6.2], [1, 51, 4.4], [1, 51, 3.2], [1, 51, 3.8], [1, 51, 5.5], [1, 51, 8.4], [1, 51, 12.4], [1, 51, 17.7], [1, 51, 24], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 51, 29], [1, 51, 23.8], [1, 51, 19.2], [1, 51, 15.1], [1, 51, 11.6], [1, 51, 8.6], [1, 51, 6.2], [1, 51, 4.4], [1, 51, 3.2], [1, 51, 3.8], [1, 51, 5.5], [1, 51, 8.4], [1, 51, 12.4], [1, 51, 17.7], [1, 51, 24], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [1, 51, 29], [1, 51, 23.8], [1, 51, 19.2], [1, 51, 15.1], [1, 51, 11.6], [1, 51, 8.6], [1, 51, 6.2], [1, 51, 4.4], [1, 51, 3.2], [1, 51, 3.8], [1, 51, 5.5], [1, 51, 8.4], [1, 51, 12.4], [1, 51, 17.7], [1, 51, 24], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0], [0]] }
  }
};

exports.default = ConfigScene;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var EVENTS = exports.EVENTS = {
  SCENE_ASSETS_LOAD_UPDATE: 'SCENE_ASSETS_LOAD_UPDATE',
  SCENE_ASSETS_LOADED: 'SCENE_ASSETS_LOADED',
  SCENE_READY: 'SCENE_READY',

  MOVE_TO_HEAVEN_START: 'MOVE_TO_HEAVEN_START',
  MOVE_TO_HEAVEN_END: 'MOVE_TO_HEAVEN_END',
  MOVE_TO_TOWN_START: 'MOVE_TO_TOWN_START',
  MOVE_TO_TOWN_END: 'MOVE_TO_TOWN_END',

  SHOW_GOD: 'SHOW_GOD'
};

exports.default = null;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConfigPage = {
  // items debug draw
  DEBUG: false,

  // base vars
  DAYS_TOTAL: 24,

  // paths
  PKG_MAIN: 'advent2017/',
  PKG_DATA: 'advent2017-data/',
  PKG_SOUNDS: 'advent2017-sounds/',

  // css classes
  CSS_INSIDE: 'inside',
  CSS_OUTSIDE: 'outside',
  CSS_HOVER: 'do-hover',

  // static content
  FIXED_WINS: ['o-projektu', 'napistenam', 'soutez', 'gramofon', 'komiks', 'galerie', 'tradicnik', 'vanocni-tv', 'tapety', 'omalovanky']
};

exports.default = ConfigPage;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HeavenItem = function () {
  function HeavenItem(data) {
    _classCallCheck(this, HeavenItem);

    // vars
    this.data = data;
    this.position = {
      z: 1 - this.data.type.split('_')[1] / 100,
      base: {
        x: this.data.iX,
        y: this.data.iY
      },
      parallax: {
        x: 0,
        y: 0
      },
      float: {
        x: 0,
        y: 0
      },
      item: {
        x: 0,
        y: 0
      }
    };
  }

  // --------------------------------------------------------------
  // Float
  // --------------------------------------------------------------

  _createClass(HeavenItem, [{
    key: 'floatStart',
    value: function floatStart() {
      this.floatAnimX();
      this.floatAnimY();
    }
  }, {
    key: 'floatStop',
    value: function floatStop() {
      TweenMax.killTweensOf(this.position.float);
    }
  }, {
    key: 'floatAnimX',
    value: function floatAnimX() {
      TweenMax.to(this.position.float, 7 + Math.random() * 7, {
        x: -15 + Math.random() * 30,
        ease: Sine.easeInOut,
        onComplete: this.floatAnimX,
        onCompleteScope: this
      });
    }
  }, {
    key: 'floatAnimY',
    value: function floatAnimY() {
      TweenMax.to(this.position.float, 7 + Math.random() * 7, {
        y: -15 + Math.random() * 30,
        ease: Sine.easeInOut,
        onComplete: this.floatAnimY,
        onCompleteScope: this
      });
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      // compute parallax position
      this.position.parallax.x = this.position.base.x + aScene.iManager.stageRatio.half.x * (_ConfigScene2.default.MOVE_DIFF_SKY.X * this.position.z);
      this.position.parallax.y = this.position.base.y + aScene.iManager.stageRatio.half.y * (_ConfigScene2.default.MOVE_DIFF_SKY.Y * this.position.z);

      // combine with float
      this.position.item.x = this.position.parallax.x + this.position.float.x;
      this.position.item.y = this.position.parallax.y + this.position.float.y;
    }
  }]);

  return HeavenItem;
}();

exports.default = HeavenItem;

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _AnScene = __webpack_require__(22);

var _AnScene2 = _interopRequireDefault(_AnScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

aScene = new _AnScene2.default();
aScene.init();

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CollisionHelper = __webpack_require__(23);

var _CollisionHelper2 = _interopRequireDefault(_CollisionHelper);

var _ItemsHelper = __webpack_require__(24);

var _ItemsHelper2 = _interopRequireDefault(_ItemsHelper);

var _MnAssetLoader = __webpack_require__(25);

var _MnAssetLoader2 = _interopRequireDefault(_MnAssetLoader);

var _SndManager = __webpack_require__(26);

var _SndManager2 = _interopRequireDefault(_SndManager);

var _InteractiveManager = __webpack_require__(27);

var _InteractiveManager2 = _interopRequireDefault(_InteractiveManager);

var _OldBrowserMsg = __webpack_require__(28);

var _OldBrowserMsg2 = _interopRequireDefault(_OldBrowserMsg);

var _SceneCont = __webpack_require__(29);

var _SceneCont2 = _interopRequireDefault(_SceneCont);

var _InfoBubble = __webpack_require__(52);

var _InfoBubble2 = _interopRequireDefault(_InfoBubble);

var _SceneManager = __webpack_require__(53);

var _SceneManager2 = _interopRequireDefault(_SceneManager);

var _Events = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AnScene = function () {
  function AnScene() {
    _classCallCheck(this, AnScene);

    // vars
    this.inited = false;

    // helpers
    this.itemsHelper = null;
    this.assetLoader = null;
    this.iManager = null;
    this.sndManager = null;
    this.sceneManager = null;

    // pools
    this.dataPool = {};
    this.imgPool = {};
    this.daysInfoArr = [];
    this.staticInfoArr = [];

    // pixi
    this.pixi = null;

    // parts
    this.infoBubble = null;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(AnScene, [{
    key: 'init',
    value: function init() {
      // disable miltiple init
      if (this.inited) {
        return;
      }
      this.inited = true;

      // check old browsers
      if (!Modernizr.audio || !Modernizr.canvas || !Modernizr.video) {
        this.oldBrowserState();
        return;
      }

      // signals
      this.initSignals();

      // helpers
      this.collisionHelper = new _CollisionHelper2.default();
      this.itemsHelper = new _ItemsHelper2.default();
      this.assetLoader = new _MnAssetLoader2.default();
      this.sndManager = new _SndManager2.default();
      this.sceneManager = new _SceneManager2.default();

      // load assets
      this.assetLoader.loadMainAssets();
    }
  }, {
    key: 'setContent',
    value: function setContent() {
      // save days data reference
      this.daysInfoArr = this.dataPool['activities-info'].days;
      this.staticInfoArr = this.dataPool['activities-info'].static;

      // init pixi
      this.initPixi();

      // main parts
      this.setMainParts();

      // mouse
      this.iManager = new _InteractiveManager2.default();

      // init resize
      this.initResize();

      // loop
      this.initLoop();

      // ready call - all set & loaded
      this.contentReady();
    }

    // --------------------------------------------------------------
    // Ready
    // --------------------------------------------------------------

  }, {
    key: 'contentReady',
    value: function contentReady() {
      // ready call - to hide main part loader
      aPage.signals.mainCall.dispatch(_Events.EVENTS.SCENE_READY);
      // init render - to render init state
      this.loopUpdate();
    }

    // --------------------------------------------------------------
    // Old browsers
    // --------------------------------------------------------------

  }, {
    key: 'oldBrowserState',
    value: function oldBrowserState() {
      new _OldBrowserMsg2.default();
    }

    // --------------------------------------------------------------
    // Signals
    // --------------------------------------------------------------

  }, {
    key: 'initSignals',
    value: function initSignals() {
      this.signals = {
        sceneCallMain: new signals.Signal(), // main part events
        itemCall: new signals.Signal(), // items interaction calls
        infoCall: new signals.Signal(), // info bubble calls
        loopCall: new signals.Signal(), // loop update signal
        pxRescall: new signals.Signal() // main part (pixi) resize call
      };
      // lsns
      this.signals.sceneCallMain.add(this.callMainFc, this);
    }
  }, {
    key: 'callMainFc',
    value: function callMainFc(sgType) {
      switch (sgType) {
        case _Events.EVENTS.SCENE_ASSETS_LOADED:
          // assets loaded set + start content
          this.setContent();
          break;
        default:
      }
    }

    // --------------------------------------------------------------
    // Pixi
    // --------------------------------------------------------------

  }, {
    key: 'initPixi',
    value: function initPixi() {
      var rendererOptions = {
        antialiasing: true,
        transparent: false,
        resolution: 1,
        view: $('#main-canvas')[0],
        backgroundColor: 0x4f696d
      };
      this.pixi = new PIXI.Application(aPage.resizer.canvasW, aPage.resizer.canvasH, rendererOptions);
      aPage.features.isCanvas = this.pixi.renderer instanceof PIXI.CanvasRenderer;
    }

    // --------------------------------------------------------------
    // Parts
    // --------------------------------------------------------------

  }, {
    key: 'setMainParts',
    value: function setMainParts() {
      // layers
      this.pixi.stage.addChild(new _SceneCont2.default());
      // info
      this.infoBubble = new _InfoBubble2.default();
      this.pixi.stage.addChild(this.infoBubble);
    }

    // --------------------------------------------------------------
    // Resize
    // --------------------------------------------------------------

  }, {
    key: 'initResize',
    value: function initResize() {
      // init update
      this.resUp();
      // add listener - to main page resize
      aPage.signals.resCall.add(this.resUp, this);
    }
  }, {
    key: 'resUp',
    value: function resUp() {
      // resize main part
      this.pixi.renderer.resize(aPage.resizer.canvasW, aPage.resizer.canvasH);

      // try resize parts
      this.signals.pxRescall.dispatch();
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'initLoop',
    value: function initLoop() {
      var _this = this;

      this.pixi.ticker.add(function () {
        if (aPage.isActive) {
          _this.loopUpdate();
        }
      });
    }
  }, {
    key: 'loopUpdate',
    value: function loopUpdate() {
      // ease position
      this.iManager.easePosition();
      // update parts
      this.sceneManager.msFrame = Math.min(this.pixi.ticker.elapsedMS, 30);
      this.signals.loopCall.dispatch();
    }
  }]);

  return AnScene;
}();

exports.default = AnScene;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CollisionHelper = function () {
  function CollisionHelper() {
    _classCallCheck(this, CollisionHelper);

    // temp vars
    this.tempX = 0;
    this.tempY = 0;
    this.tempR = 0;
  }

  // --------------------------------------------------------------
  // Circle
  // --------------------------------------------------------------

  _createClass(CollisionHelper, [{
    key: "hitCircle",
    value: function hitCircle(posPt, hitData) {
      var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      this.tempX = posPt.x - aScene.iManager.stage.x;
      this.tempY = posPt.y - aScene.iManager.stage.y;
      this.tempR = scale ? hitData.hR * aPage.resizer.scaleMain : hitData.hR;
      return Math.sqrt(this.tempX * this.tempX + this.tempY * this.tempY) <= this.tempR;
    }

    // --------------------------------------------------------------
    // Rectangle
    // --------------------------------------------------------------

  }, {
    key: "hitRect",
    value: function hitRect(posPt, hitData) {
      this.tempX = aScene.iManager.stage.x - posPt.x;
      this.tempY = aScene.iManager.stage.y - posPt.y;

      return this.tempX >= 0 && this.tempX <= hitData.hW * aPage.resizer.scaleMain && this.tempY >= 0 && this.tempY <= hitData.hH * aPage.resizer.scaleMain;
    }
  }]);

  return CollisionHelper;
}();

exports.default = CollisionHelper;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ItemsHelper = function () {
  function ItemsHelper() {
    _classCallCheck(this, ItemsHelper);

    // vars
    this.items = [];
    this.activeItem = null;
    this.helpBullets = false; // true/false - to switch help bullets
    this.hitFound = false;
    this.hitEnabled = true; // to prevent in touch mode

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(ItemsHelper, [{
    key: 'init',
    value: function init() {
      // loop lsn
      aScene.signals.loopCall.add(this.loop, this);
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loop',
    value: function loop() {
      if (aScene.sceneManager.sceneState === 0) {
        // hit test
        this.hitFound = false;
        if (!aScene.infoBubble.overCheck() && this.hitEnabled) {
          for (var i = 0; i < this.items.length; i += 1) {
            if (this.items[i].tryHit()) {
              this.hitFound = true;
              // save item reference
              this.activeItem = this.items[i];
              // cursor
              aScene.iManager.setPointerCursor(true);
              // hover call
              aScene.signals.itemCall.dispatch(_ConfigScene2.default.E_ITEM_HOVER, this.activeItem.itemId);
              break;
            }
          }
        }

        // no hit found -> try un-hover
        if (!this.hitFound) {
          this.deSelectItem();
        }
      }
    }

    // --------------------------------------------------------------
    // Select
    // --------------------------------------------------------------

  }, {
    key: 'trySelectItem',
    value: function trySelectItem() {
      if (this.activeItem) {
        if (aPage.features.isTouch && !aPage.features.isMouse) {
          if (this.activeItem.touchUps > 0) {
            this.selectItem();
          } else {
            this.activeItem.touchUps += 1;
          }
        } else {
          this.selectItem();
        }
      }
    }
  }, {
    key: 'deSelectItem',
    value: function deSelectItem() {
      if (this.activeItem) {
        this.activeItem = null;
        // cursor
        aScene.iManager.setPointerCursor(false);
        // un-hover
        aScene.signals.itemCall.dispatch(_ConfigScene2.default.E_ITEM_HOVER, -1);
      }
    }
  }, {
    key: 'selectItem',
    value: function selectItem() {
      if (!aPage.isArchive) {
        // cursor
        aScene.iManager.setPointerCursor(false);
        // un-hover
        aScene.signals.itemCall.dispatch(_ConfigScene2.default.E_ITEM_HOVER, -1);
        // bubble event
        aScene.signals.infoCall.dispatch(_ConfigScene2.default.E_INFO_BLL_SHOW, [this.activeItem.itemId, this.activeItem.getBulletPos()]);
        // reset active item
        this.activeItem = null;
      }
    }
  }]);

  return ItemsHelper;
}();

exports.default = ItemsHelper;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigPage = __webpack_require__(2);

var _ConfigPage2 = _interopRequireDefault(_ConfigPage);

var _Events = __webpack_require__(1);

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MnAssetLoader = function () {
  function MnAssetLoader() {
    _classCallCheck(this, MnAssetLoader);

    // vars
    this.pkgDataPrefix = '';
    this.pixiLoader = null;

    // data
    this.dataLoadPool = [];
    this.actualData = null;
  }

  // --------------------------------------------------------------
  // Main
  // --------------------------------------------------------------

  _createClass(MnAssetLoader, [{
    key: 'loadMainAssets',
    value: function loadMainAssets() {
      // set vars
      this.pkgDataPrefix = aPage.pathPrefix + _ConfigPage2.default.PKG_DATA;

      // start with data
      this.loadMainData();
    }
  }, {
    key: 'assetsLoaded',
    value: function assetsLoaded() {
      aScene.signals.sceneCallMain.dispatch(_Events.EVENTS.SCENE_ASSETS_LOADED);
    }

    // --------------------------------------------------------------
    // Data
    // --------------------------------------------------------------

  }, {
    key: 'loadMainData',
    value: function loadMainData() {
      this.dataLoadPool = [['heaven', this.pkgDataPrefix + 'data/heaven.json'], ['transition', this.pkgDataPrefix + 'data/transition.json'], ['town', this.pkgDataPrefix + 'data/town.json'], ['activities-info', this.pkgDataPrefix + 'data/activities-info.json']];
      this.addDaysData();

      this.tryLoadNextData();
    }
  }, {
    key: 'tryLoadNextData',
    value: function tryLoadNextData() {
      var _this = this;

      if (this.dataLoadPool.length > 0) {
        this.actualData = this.dataLoadPool.pop();
        $.get(this.actualData[1]).done(function (data) {
          aScene.dataPool[_this.actualData[0]] = data;
          _this.tryLoadNextData();
        }).fail(function (jqxhr, settings, exception) {
          console.log('Data file load error', exception);
        });
      } else {
        this.dataLoaded();
      }
    }
  }, {
    key: 'addDaysData',
    value: function addDaysData() {
      for (var i = 0; i < actionUuids.length; i += 1) {
        this.dataLoadPool.push(['day-' + i, this.pkgDataPrefix + 'data/days/' + (i + 1) + '-' + actionUuids[i] + '.json']);
      }
    }
  }, {
    key: 'dataLoaded',
    value: function dataLoaded() {
      aPage.signals.mainCall.dispatch(_Events.EVENTS.SCENE_ASSETS_LOAD_UPDATE, 0.2);
      // continue with images
      this.loadMainImages();
    }

    // --------------------------------------------------------------
    // Images
    // --------------------------------------------------------------

  }, {
    key: 'loadMainImages',
    value: function loadMainImages() {
      var _this2 = this;

      this.pixiLoader = PIXI.loader;
      // sheets
      this.pixiLoader.add('st-main', this.pkgDataPrefix + 'img/main/st-main.json');
      this.pixiLoader.add('st-angels', this.pkgDataPrefix + 'img/main/st-angels.json');
      this.pixiLoader.add('st-gui', this.pkgDataPrefix + 'img/main/st-gui.json');

      // images
      this.addLoadImage('lr-bg-0', this.pkgDataPrefix + 'img/main/layers/lr-bg-0.jpg');
      this.addLoadImage('lr-bg-1', this.pkgDataPrefix + 'img/main/layers/lr-bg-1.jpg');

      _ConfigScene2.default.TOWN_LAYERS.forEach(function (townLr) {
        townLr.forEach(function (townBm) {
          _this2.addLoadImage(townBm.bm, _this2.pkgDataPrefix + 'img/main/layers/' + townBm.bm + '.png');
        });
      });

      _ConfigScene2.default.TOWN_SNOW_OVER.forEach(function (snowLr) {
        snowLr.forEach(function (snowBm) {
          _this2.addLoadImage(snowBm.bm, _this2.pkgDataPrefix + 'img/main/layers/' + snowBm.bm + '.png');
        });
      });

      // listeners
      this.pixiLoader.onProgress.add(function () {
        aPage.signals.mainCall.dispatch(_Events.EVENTS.SCENE_ASSETS_LOAD_UPDATE, Math.min(0.2 + _this2.pixiLoader.progress / 100 * 0.8, 1));
      });
      this.pixiLoader.onComplete.add(function () {
        _this2.imagesLoaded();
      });

      // start loading
      this.pixiLoader.load();
    }
  }, {
    key: 'addLoadImage',
    value: function addLoadImage(imgId, imgUrl) {
      // save to pool
      aScene.imgPool[imgId] = imgUrl;
      // add to loader
      this.pixiLoader.add(imgId, imgUrl);
    }
  }, {
    key: 'imagesLoaded',
    value: function imagesLoaded() {
      // complete event
      aScene.assetLoader.assetsLoaded();
    }
  }]);

  return MnAssetLoader;
}();

exports.default = MnAssetLoader;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Events = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SndManager = function () {
  function SndManager() {
    _classCallCheck(this, SndManager);

    // const
    this.AMBI_VOLUME = 1.0;
    this.I_VERSIONS = {
      andel: 2,
      apatyka: 3,
      babka: 4,
      certandel: 9,
      'certandel-mikulas': 1,
      dvere: 5,
      dyk: 5,
      'dyk-mikulas': 1,
      god: 5,
      holka: 3,
      'holka-mikulas': 1,
      holub: 1,
      hospoda: 3,
      host: 4,
      klucik: 3,
      kocka: 3,
      koular: 3,
      labuda: 3,
      mama: 3,
      opilci: 4,
      pani: 3,
      pes: 3,
      polivka: 5,
      ponocny: 12,
      preclik: 2,
      puncocha: 3,
      syn: 2,
      ukolebavka: 3,
      zametani: 4,
      'zametani-mikulas': 4
    };
    this.FADE_SFX = ['ukolebavka', 'hospoda'];

    // main vars
    this.deSound = null;
    this.isMuted = false;

    // paths
    this.sndPath = '/cms/advent2017-sounds/snd/';
    this.quality = '-hi';

    // ambi
    this.ambiActive = false;
    this.ambiLoop = null;
    this.ambiType = -10;

    // items sfx
    this.itemsPool = {};
    this.itemSfx = null;
    this.itemTempId = 0;
    this.actualItemName = ''; // for stop
    this.itemTempName = '';

    // sfx
    this.actualSfx = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(SndManager, [{
    key: 'init',
    value: function init() {
      // settings
      if (aPage.features.isLocal) {
        this.sndPath = '../../advent2017-sounds/snd/';
      }
      /*
      if (aPage.features.isMobile) {
        this.quality = '-lo';
      }
      */
      // init manager
      if (aPage.iOsSndManagerRef) {
        this.deSound = aPage.iOsSndManagerRef;
      } else {
        this.deSound = new DeSnd.SoundManager();
      }

      // muter
      this.setAutoMute();

      // item pools
      this.initItemPools();

      // signals
      aScene.signals.sceneCallMain.add(this.callMainFc, this);
    }
  }, {
    key: 'setAutoMute',
    value: function setAutoMute() {
      var _this = this;

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          _this.deSound.mute = true;
        } else if (!_this.isMuted) {
          _this.deSound.mute = false;
        }
      }, false);
    }

    // --------------------------------------------------------------
    // Main Call
    // --------------------------------------------------------------

  }, {
    key: 'callMainFc',
    value: function callMainFc(sgType) {
      var _this2 = this;

      switch (sgType) {
        case _Events.EVENTS.MOVE_TO_HEAVEN_START:
        case _Events.EVENTS.MOVE_TO_TOWN_START:
          this.stopAmbi();
          setTimeout(function () {
            _this2.startAmbi(sgType === _Events.EVENTS.MOVE_TO_TOWN_START ? 0 : 1);
          }, 2500);
          break;
        default:
      }
    }

    // --------------------------------------------------------------
    // Disable Mute - called from colorbox
    // --------------------------------------------------------------

  }, {
    key: 'disableMute',
    value: function disableMute(doMute) {
      this.isMuted = doMute;
      this.deSound.mute = doMute;
    }

    // --------------------------------------------------------------
    // Ambi Loop
    // --------------------------------------------------------------

  }, {
    key: 'playAmbi',
    value: function playAmbi(doPlay) {
      sndMuted = !doPlay;
      this.ambiActive = doPlay;
      if (this.ambiActive) {
        this.startAmbi(aScene.sceneManager.sceneDestination);
      } else {
        this.stopAmbi();
      }
    }
  }, {
    key: 'startAmbi',
    value: function startAmbi(type) {
      if (this.ambiActive) {
        if (this.ambiLoop && this.ambiType === type) {
          this.ambiLoop.play();
          this.ambiLoop.fade(this.ambiLoop.volume, this.AMBI_VOLUME, 500);
        } else if (type !== -1) {
          // init/swap - blocked during transition
          this.setAmbi(type);
        }
      }
    }
  }, {
    key: 'stopAmbi',
    value: function stopAmbi() {
      if (this.ambiLoop) {
        this.ambiLoop.pause();
      }
    }
  }, {
    key: 'setAmbi',
    value: function setAmbi(type) {
      this.ambiType = type;
      if (this.ambiType === 0) {
        // town
        this.ambiLoop = this.getAmbi('ambi-0-' + Math.round(Math.random()));
      } else if (this.ambiType === 1) {
        // heaven
        this.ambiLoop = this.getAmbi('ambi-1-0');
      }
    }
  }, {
    key: 'getAmbi',
    value: function getAmbi(ambiName) {
      var ambi = this.deSound.addSound(ambiName, this.sndPath + 'ambient/' + ambiName + this.quality);
      ambi.loop = true;
      ambi.fadeDuration = 500;
      ambi.inFade = true;
      ambi.outFade = true;
      ambi.volume = this.AMBI_VOLUME;
      ambi.play();
      return ambi;
    }
  }, {
    key: 'muteAmbi',
    value: function muteAmbi(doMute) {
      if (this.ambiActive && this.ambiLoop) {
        if (doMute) {
          this.ambiLoop.fade(this.AMBI_VOLUME, 0, 500);
        } else {
          this.ambiLoop.fade(0, this.AMBI_VOLUME, 300);
        }
      }
    }

    // --------------------------------------------------------------
    // Items
    // --------------------------------------------------------------

  }, {
    key: 'initItemPools',
    value: function initItemPools() {
      var _this3 = this;

      Object.keys(this.I_VERSIONS).forEach(function (key) {
        _this3.itemsPool[key] = {
          last: -1,
          pool: []
        };
        _this3.setItemPool(key);
      });
    }
  }, {
    key: 'setItemPool',
    value: function setItemPool(itemName) {
      for (var a = 0; a < this.I_VERSIONS[itemName]; a += 1) {
        if (a !== this.itemsPool[itemName].last || this.I_VERSIONS[itemName] === 1) {
          this.itemsPool[itemName].pool.push(a);
        }
      }
    }
  }, {
    key: 'playItemSfx',
    value: function playItemSfx(itemName) {
      // try stop old
      this.stopItemSfx(this.actualItemName);
      this.actualItemName = itemName;

      // get id
      if (this.itemsPool[itemName].pool.length === 0) {
        this.setItemPool(itemName);
      }
      this.itemsPool[itemName].last = this.itemsPool[itemName].pool.splice(Math.round(Math.random() * (this.itemsPool[itemName].pool.length - 1)), 1)[0];
      this.itemTempId = this.itemsPool[itemName].last;

      // set name
      this.itemTempName = 'i-' + itemName + '-' + this.itemTempId;

      // play
      this.itemSfx = this.deSound.addSound(this.itemTempName, this.sndPath + 'sfx/items/' + this.itemTempName + this.quality);
      this.itemSfx.outFade = true;
      if (aPage.features.isTouch) {
        this.itemSfx.once('complete', this.itemSfxComplete, this);
      }
      this.itemSfx.play();

      // try ambi mute
      if (this.FADE_SFX.indexOf(itemName) !== -1) {
        this.muteAmbi(true);
      }
    }
  }, {
    key: 'stopItemSfx',
    value: function stopItemSfx(itemName) {
      if (this.itemSfx && this.actualItemName === itemName) {
        this.itemSfx.stop();
        this.itemSfx = null;

        // try ambi mute
        if (this.FADE_SFX.indexOf(itemName) !== -1) {
          this.muteAmbi(false);
        }
      }
    }
  }, {
    key: 'itemSfxComplete',
    value: function itemSfxComplete() {
      aScene.itemsHelper.hitEnabled = false;
      aScene.itemsHelper.deSelectItem();
    }

    // --------------------------------------------------------------
    // Sfx
    // --------------------------------------------------------------

  }, {
    key: 'playSfx',
    value: function playSfx(sfxName) {
      this.actualSfx = this.deSound.addSound(sfxName, this.sndPath + 'sfx/' + sfxName + this.quality).play();
    }
  }]);

  return SndManager;
}();

exports.default = SndManager;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InteractiveManager = function () {
  function InteractiveManager() {
    _classCallCheck(this, InteractiveManager);

    // const
    this.MOVE_EASE = 0.09;

    // cursor
    this.isPointer = false;

    // stage position - not scaled
    this.stage = {
      x: 0,
      y: 0
    };
    // stage percentage position - 0-1
    this.stageRatioBase = {
      x: _ConfigScene2.default.INIT_POS_X,
      y: _ConfigScene2.default.INIT_POS_Y
    };
    // stage percentage position - 0-1 - eased
    this.stageRatio = {
      x: _ConfigScene2.default.INIT_POS_X,
      y: _ConfigScene2.default.INIT_POS_Y,
      half: {
        x: _ConfigScene2.default.INIT_POS_X - 0.5,
        y: _ConfigScene2.default.INIT_POS_Y - 0.5
      }
    };

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(InteractiveManager, [{
    key: 'init',
    value: function init() {
      var _this = this;

      aScene.pixi.stage.interactive = true;

      aScene.pixi.stage.on('mousemove', function () {
        aPage.features.isMouse = true;
      });

      aScene.pixi.stage.on('touchstart', function (e) {
        aPage.features.isMouse = false;
        aScene.itemsHelper.hitEnabled = true;
        _this.tMove(e);
      });

      aScene.pixi.stage.on('pointerup', function () {
        aScene.itemsHelper.trySelectItem();
      });

      aScene.pixi.stage.on('pointermove', function (e) {
        aScene.itemsHelper.hitEnabled = true;
        _this.pMove(e);
      });
    }

    // --------------------------------------------------------------
    // Move
    // --------------------------------------------------------------

  }, {
    key: 'pMove',
    value: function pMove(e) {
      this.stage.x = e.data.global.x;
      this.stage.y = e.data.global.y;
      this.moveShared();
    }
  }, {
    key: 'tMove',
    value: function tMove(e) {
      this.stage.x = e.data.originalEvent.touches[0].clientX - aPage.resizer.canvasSide;
      this.stage.y = e.data.originalEvent.touches[0].clientY - aPage.resizer.canvasTop;
      this.moveShared();
    }
  }, {
    key: 'moveShared',
    value: function moveShared() {
      this.stageRatioBase.x = Math.min(Math.max(this.stage.x / aPage.resizer.canvasW, 0), 1);
      this.stageRatioBase.y = Math.min(Math.max(this.stage.y / aPage.resizer.canvasH, 0), 1);
    }

    // --------------------------------------------------------------
    // Cursor
    // --------------------------------------------------------------

  }, {
    key: 'setPointerCursor',
    value: function setPointerCursor(doSet) {
      if (doSet && !this.isPointer) {
        this.isPointer = true;
        document.body.style.cursor = 'pointer';
      } else if (!doSet && this.isPointer) {
        this.isPointer = false;
        document.body.style.cursor = 'default';
      }
    }

    // --------------------------------------------------------------
    // Loop - ease
    // --------------------------------------------------------------

  }, {
    key: 'easePosition',
    value: function easePosition() {
      this.stageRatio.x += (this.stageRatioBase.x - this.stageRatio.x) * this.MOVE_EASE;
      this.stageRatio.y += (this.stageRatioBase.y - this.stageRatio.y) * this.MOVE_EASE;
      this.stageRatio.half.x = this.stageRatio.x - 0.5;
      this.stageRatio.half.y = this.stageRatio.y - 0.5;
    }
  }]);

  return InteractiveManager;
}();

exports.default = InteractiveManager;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigPage = __webpack_require__(2);

var _ConfigPage2 = _interopRequireDefault(_ConfigPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OldBrowserMsg = function () {
  function OldBrowserMsg() {
    _classCallCheck(this, OldBrowserMsg);

    // const
    this.BG_W = 1370;
    this.BG_H = 650;

    // resize vars
    this.sMain = 0;
    this.rW = 0;
    this.rH = 0;

    // parts
    this.msgImg = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(OldBrowserMsg, [{
    key: 'init',
    value: function init() {
      this.msgImg = $('<img id="msg-old-browser">');
      this.msgImg.attr('src', '' + aPage.pathPrefix + _ConfigPage2.default.PKG_DATA + 'img/page/msg-old-browser.jpg');
      $('#main-preloader').append(this.msgImg);

      // add resize lsn
      aPage.signals.resCall.add(this.resUp, this);
      this.resUp();
    }

    // --------------------------------------------------------------
    // Resize
    // --------------------------------------------------------------

  }, {
    key: 'resUp',
    value: function resUp() {
      this.sMain = Math.max(aPage.resizer.canvasW / this.BG_W, aPage.resizer.canvasH / this.BG_H);
      // set
      this.rW = this.BG_W * this.sMain;
      this.rH = this.BG_H * this.sMain;
      this.msgImg.css({
        width: this.rW,
        height: this.rH,
        top: -(this.rH - aPage.resizer.canvasH) * 0.5,
        left: -(this.rW - aPage.resizer.canvasW) * 0.5
      });
    }
  }]);

  return OldBrowserMsg;
}();

exports.default = OldBrowserMsg;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

var _BgSky = __webpack_require__(30);

var _BgSky2 = _interopRequireDefault(_BgSky);

var _Town = __webpack_require__(31);

var _Town2 = _interopRequireDefault(_Town);

var _Transition = __webpack_require__(41);

var _Transition2 = _interopRequireDefault(_Transition);

var _Heaven = __webpack_require__(43);

var _Heaven2 = _interopRequireDefault(_Heaven);

var _TownSnow = __webpack_require__(50);

var _TownSnow2 = _interopRequireDefault(_TownSnow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SceneCont = function (_PIXI$Container) {
  _inherits(SceneCont, _PIXI$Container);

  function SceneCont() {
    _classCallCheck(this, SceneCont);

    // move vars
    var _this = _possibleConstructorReturn(this, (SceneCont.__proto__ || Object.getPrototypeOf(SceneCont)).call(this));

    _this.difference = {
      x: 0,
      y: 0
    };

    // parts
    _this.sky = null;
    _this.heaven = null;
    _this.transition = null;
    _this.town = null;
    _this.townSnow = null;

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(SceneCont, [{
    key: 'init',
    value: function init() {
      // parts
      this.setParts();

      // listeners
      aScene.signals.pxRescall.add(this.resUp, this);
      aScene.signals.loopCall.add(this.loopUp, this);
    }

    // --------------------------------------------------------------
    // Parts
    // --------------------------------------------------------------

  }, {
    key: 'setParts',
    value: function setParts() {
      this.sky = new _BgSky2.default();
      this.addChild(this.sky);

      this.heaven = new _Heaven2.default();
      this.addChild(this.heaven);

      this.transition = new _Transition2.default();
      this.addChild(this.transition);

      this.town = new _Town2.default();
      this.addChild(this.town);

      this.townSnow = new _TownSnow2.default(this);
    }

    // --------------------------------------------------------------
    // Resize
    // --------------------------------------------------------------

  }, {
    key: 'resUp',
    value: function resUp() {
      this.scale.x = aPage.resizer.scaleMain;
      this.scale.y = aPage.resizer.scaleMain;
      this.difference.x = _ConfigScene2.default.DIFF_X * aPage.resizer.scaleMain;
      this.difference.y = _ConfigScene2.default.DIFF_Y * aPage.resizer.scaleMain;
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      this.x = -(aPage.resizer.canvasDiffX * 0.5) - this.difference.x * aScene.iManager.stageRatio.x;
      this.y = aScene.sceneManager.offset * aPage.resizer.scaleMain - aPage.resizer.canvasDiffY * 0.5 - this.difference.y * aScene.iManager.stageRatio.y;
    }
  }]);

  return SceneCont;
}(PIXI.Container);

exports.default = SceneCont;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BgSky = function (_PIXI$Container) {
  _inherits(BgSky, _PIXI$Container);

  function BgSky() {
    _classCallCheck(this, BgSky);

    // parts
    var _this = _possibleConstructorReturn(this, (BgSky.__proto__ || Object.getPrototypeOf(BgSky)).call(this));

    _this.bg0 = null;
    _this.bg1 = null;

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(BgSky, [{
    key: 'init',
    value: function init() {
      // parts
      this.bg0 = new PIXI.Sprite.fromImage(aScene.imgPool['lr-bg-0']);
      this.addChild(this.bg0);
      this.bg1 = new PIXI.Sprite.fromImage(aScene.imgPool['lr-bg-1']);
      this.bg1.y = this.bg0.height;
      this.addChild(this.bg1);

      // loop
      aScene.signals.loopCall.add(this.loopUp, this);
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      this.x = _ConfigScene2.default.MOVE_DIFF_SKY.X * aScene.iManager.stageRatio.half.x;
      this.y = _ConfigScene2.default.MOVE_DIFF_SKY.Y * aScene.iManager.stageRatio.half.y;
    }
  }]);

  return BgSky;
}(PIXI.Container);

exports.default = BgSky;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TownLayer = __webpack_require__(32);

var _TownLayer2 = _interopRequireDefault(_TownLayer);

var _BulletLayer = __webpack_require__(38);

var _BulletLayer2 = _interopRequireDefault(_BulletLayer);

var _Events = __webpack_require__(1);

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

var _Clock = __webpack_require__(40);

var _Clock2 = _interopRequireDefault(_Clock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Town = function (_PIXI$Container) {
  _inherits(Town, _PIXI$Container);

  function Town() {
    _classCallCheck(this, Town);

    // parts
    var _this = _possibleConstructorReturn(this, (Town.__proto__ || Object.getPrototypeOf(Town)).call(this));

    _this.bulletsCont = null;

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(Town, [{
    key: 'init',
    value: function init() {
      // props
      this.y = _ConfigScene2.default.SIZES.SCENE_CONT_HEIGHT - _ConfigScene2.default.SIZES.SCENE_ACTIVE_HEIGHT;

      // clock - just sound handler
      new _Clock2.default();

      // containers
      var layersCont = new PIXI.Container();
      this.addChild(layersCont);

      this.bulletsCont = new PIXI.Container();
      this.addChild(this.bulletsCont);

      // set layers
      for (var i = 0; i <= 3; i += 1) {
        layersCont.addChild(new _TownLayer2.default(i));
        this.bulletsCont.addChild(new _BulletLayer2.default(i));
      }

      // signals
      aScene.signals.sceneCallMain.add(this.callMainFc, this);
    }
  }, {
    key: 'showBullets',
    value: function showBullets(doShow) {
      TweenMax.killTweensOf(this.bulletsCont);
      TweenMax.to(this.bulletsCont, 0.6, {
        alpha: doShow ? 1 : 0
      });
    }

    // --------------------------------------------------------------
    // Main Call
    // --------------------------------------------------------------

  }, {
    key: 'callMainFc',
    value: function callMainFc(sgType) {
      switch (sgType) {
        case _Events.EVENTS.MOVE_TO_HEAVEN_START:
          this.showBullets(false);
          break;
        case _Events.EVENTS.MOVE_TO_TOWN_END:
          this.showBullets(true);
          break;
        case _Events.EVENTS.MOVE_TO_TOWN_START:
          this.visible = true;
          break;
        case _Events.EVENTS.MOVE_TO_HEAVEN_END:
          this.visible = false;
          break;
        default:
      }
    }
  }]);

  return Town;
}(PIXI.Container);

exports.default = Town;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

var _ActiveItem = __webpack_require__(33);

var _ActiveItem2 = _interopRequireDefault(_ActiveItem);

var _SwitchAngel = __webpack_require__(34);

var _SwitchAngel2 = _interopRequireDefault(_SwitchAngel);

var _SmokeStream = __webpack_require__(35);

var _SmokeStream2 = _interopRequireDefault(_SmokeStream);

var _SnowOverlay = __webpack_require__(37);

var _SnowOverlay2 = _interopRequireDefault(_SnowOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TownLayer = function (_PIXI$Container) {
  _inherits(TownLayer, _PIXI$Container);

  function TownLayer(layerId) {
    _classCallCheck(this, TownLayer);

    // vars
    var _this = _possibleConstructorReturn(this, (TownLayer.__proto__ || Object.getPrototypeOf(TownLayer)).call(this));

    _this.layerId = layerId;
    _this.bgLayers = 0;

    // move
    _this.moveDiff = [0, 0];
    _this.scaleDiff = 0;

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(TownLayer, [{
    key: 'init',
    value: function init() {
      // vars
      this.moveDiff = _ConfigScene2.default.MOVE_DIFF_ITEMS[this.layerId];
      this.scaleDiff = _ConfigScene2.default.TOWN_SCALE_DIFF[this.layerId];

      // parts
      this.setBg();
      this.setItems();
      this.setExtra();
      this.setSnow();

      // listeners
      aScene.signals.loopCall.add(this.loopUp, this);
    }

    // --------------------------------------------------------------
    // Bg
    // --------------------------------------------------------------

  }, {
    key: 'setBg',
    value: function setBg() {
      var bgData = _ConfigScene2.default.TOWN_LAYERS[this.layerId];
      this.bgLayers = bgData.length; // for snow overlay
      for (var i = 0; i < this.bgLayers; i += 1) {
        var bg = new PIXI.Sprite.fromImage(aScene.imgPool[bgData[i].bm]);
        bg.x = bgData[i].x;
        bg.y = bgData[i].y;
        this.addChild(bg);
      }
    }

    // --------------------------------------------------------------
    // Extra
    // --------------------------------------------------------------

  }, {
    key: 'setExtra',
    value: function setExtra() {
      switch (this.layerId) {
        case 0:
          this.addChildAt(new _SmokeStream2.default(600, 126, 0.25, 37), 0);
          this.addChildAt(new _SmokeStream2.default(880, 177, 0.3, 35), 0);
          this.addChildAt(new _SwitchAngel2.default());
          break;
        default:
      }
    }

    // --------------------------------------------------------------
    // Items
    // --------------------------------------------------------------

  }, {
    key: 'setItems',
    value: function setItems() {
      // get items data
      var imsData = aScene.dataPool.town['lr-' + this.layerId];

      // set items
      for (var i = 0; i < imsData.length; i += 1) {
        if (this.mikulasCheck(imsData[i].id)) {
          this.addChild(new _ActiveItem2.default(imsData[i]));
        }
      }
    }
  }, {
    key: 'mikulasCheck',
    value: function mikulasCheck(itemId) {
      return aPage.mikulas && itemId.indexOf('nomik') === -1 || !aPage.mikulas && itemId.indexOf('mikulas') === -1;
    }

    // --------------------------------------------------------------
    // Snow
    // --------------------------------------------------------------

  }, {
    key: 'setSnow',
    value: function setSnow() {
      var snowData = _ConfigScene2.default.TOWN_SNOW_OVER[this.layerId];
      for (var i = 0; i < snowData.length; i += 1) {
        var bmName = snowData[i].bm;
        var snow = new _SnowOverlay2.default(PIXI.Texture.fromImage(aScene.imgPool[bmName]));
        snow.x = snowData[i].x;
        snow.y = snowData[i].y;
        if (bmName.indexOf('f') !== -1) {
          this.addChild(snow);
        } else {
          this.addChildAt(snow, this.bgLayers);
        }
      }
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      if (aScene.sceneManager.sceneState !== 1) {
        var tempScale = this.scaleDiff * aScene.sceneManager.townScale;
        var scaleDiff = _ConfigScene2.default.SIZES.SCENE_WIDTH_MAX * tempScale * 0.5;
        this.scale.x = 1 + tempScale;
        this.scale.y = 1 + tempScale;

        this.x = this.moveDiff[0] * aScene.iManager.stageRatio.half.x - scaleDiff;
        this.y = this.moveDiff[1] * aScene.iManager.stageRatio.half.y;
      }
    }
  }]);

  return TownLayer;
}(PIXI.Container);

exports.default = TownLayer;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigPage = __webpack_require__(2);

var _ConfigPage2 = _interopRequireDefault(_ConfigPage);

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActiveItem = function (_PIXI$Container) {
  _inherits(ActiveItem, _PIXI$Container);

  function ActiveItem(itemData) {
    _classCallCheck(this, ActiveItem);

    // conts
    var _this = _possibleConstructorReturn(this, (ActiveItem.__proto__ || Object.getPrototypeOf(ActiveItem)).call(this));

    _this.SLOW_FADES = [11];
    _this.FADE_SLOW = 0.5;
    _this.FADE_FAST = 0.1;

    // vars
    _this.fadeTime = 0.1;
    _this.itemId = 0;
    _this.itemName = '';
    _this.itemType = 1; // 1/2 - number of frames
    _this.itemData = itemData;
    _this.hovered = false;
    _this.touchUps = 0; // for touch select (on second tap)
    _this.isMikulas = _this.itemData.id.indexOf('mikulas') !== -1;

    // parts
    _this.zeroStateBm = null;
    _this.mainStateBm = null;

    // hit
    _this.hitFc = null; // hit function reference
    _this.globalPos = new PIXI.Point(0, 0);
    _this.hitOffset = new PIXI.Point(_this.itemData.hit.hX, _this.itemData.hit.hY);

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(ActiveItem, [{
    key: 'init',
    value: function init() {
      // props + vars
      var idArray = this.itemData.id.split('_');
      this.itemId = Number(idArray[0]);
      this.itemName = '' + idArray[1] + (this.isMikulas ? '-mikulas' : '');
      this.itemType = Number(idArray[2]);
      this.x = this.itemData.iX;
      this.y = this.itemData.iY;

      // set fade time
      if (this.SLOW_FADES.indexOf(this.itemId) === -1) {
        this.fadeTime = this.FADE_FAST;
      } else {
        this.fadeTime = this.FADE_SLOW;
      }

      // save hit function ref
      switch (this.itemData.hit.hT) {
        case 1:
          this.hitFc = aScene.collisionHelper.hitCircle;
          break;
        case 2:
          this.hitFc = aScene.collisionHelper.hitRect;
          break;
        default:
      }

      // set parts
      this.setStateBm();

      // save ref
      aScene.itemsHelper.items.push(this);

      // debug
      if (_ConfigPage2.default.DEBUG) {
        this.drawHitArea();
      }

      // lsns
      aScene.signals.itemCall.add(this.itemCallFc, this);
    }

    // --------------------------------------------------------------
    // Lsn
    // --------------------------------------------------------------

  }, {
    key: 'itemCallFc',
    value: function itemCallFc(sgType, optParams) {
      // try un/hover
      if (sgType === _ConfigScene2.default.E_ITEM_HOVER) {
        if (optParams === this.itemId) {
          this.setHoverState(true);
        } else {
          this.setHoverState(false);
        }
      }
    }

    // --------------------------------------------------------------
    // Hover
    // --------------------------------------------------------------

  }, {
    key: 'setHoverState',
    value: function setHoverState(doHover) {
      if (doHover) {
        if (!this.hovered) {
          this.touchUps = 0;
          this.hovered = true;
          this.mainStateBm.visible = true;

          if (this.itemType === 2) {
            this.zeroStateBm.visible = false;
          } else {
            // effect
            TweenMax.killTweensOf(this.mainStateBm);
            TweenMax.to(this.mainStateBm, this.fadeTime, { alpha: 1.0 });
          }
          // play sfx
          aScene.sndManager.playItemSfx(this.itemName);
        }
      } else if (this.hovered) {
        this.hovered = false;

        if (this.itemType === 2) {
          this.zeroStateBm.visible = true;
          this.mainStateBm.visible = false;
        } else {
          // effect
          TweenMax.killTweensOf(this.mainStateBm);
          TweenMax.to(this.mainStateBm, this.fadeTime, {
            alpha: 0.0,
            onComplete: this.unHoverEnd,
            onCompleteScope: this
          });
        }
        // try stop sfx
        aScene.sndManager.stopItemSfx(this.itemName);
      }
    }
  }, {
    key: 'unHoverEnd',
    value: function unHoverEnd() {
      this.mainStateBm.visible = false;
    }

    // --------------------------------------------------------------
    // State bitmap
    // --------------------------------------------------------------

  }, {
    key: 'setStateBm',
    value: function setStateBm() {
      // main
      this.mainStateBm = new PIXI.Sprite.fromFrame(this.itemName + '-1.png');
      this.addChild(this.mainStateBm);
      // init state
      this.mainStateBm.visible = false;
      // try zero
      if (this.itemType === 2) {
        this.zeroStateBm = new PIXI.Sprite.fromFrame(this.itemName + '-0.png');
        this.addChild(this.zeroStateBm);
      } else {
        this.mainStateBm.alpha = 0;
      }
    }

    // --------------------------------------------------------------
    // HitArea
    // --------------------------------------------------------------

  }, {
    key: 'drawHitArea',
    value: function drawHitArea() {
      var debugGr = new PIXI.Graphics();
      debugGr.beginFill('0xFF0000', 0.4);
      if (this.itemData.hit) {
        switch (this.itemData.hit.hT) {
          case 1:
            debugGr.drawCircle(this.itemData.hit.hX, this.itemData.hit.hY, this.itemData.hit.hR);
            break;
          case 2:
            debugGr.drawRect(this.itemData.hit.hX, this.itemData.hit.hY, this.itemData.hit.hW, this.itemData.hit.hH);
            break;
          default:
        }
      }
      debugGr.endFill();
      this.addChild(debugGr);
    }

    // --------------------------------------------------------------
    // Hit
    // --------------------------------------------------------------

  }, {
    key: 'tryHit',
    value: function tryHit() {
      // global hit position
      aScene.pixi.stage.toLocal(this.hitOffset, this, this.globalPos);
      // try hit
      return this.hitFc.call(this, this.globalPos, this.itemData.hit);
    }

    // --------------------------------------------------------------
    // Bullet position
    // --------------------------------------------------------------

  }, {
    key: 'getBulletPos',
    value: function getBulletPos() {
      return {
        x: (this.itemData.iX + this.itemData.hint.hX) * aPage.resizer.scaleMain,
        y: (this.itemData.iY + this.itemData.hint.hY) * aPage.resizer.scaleMain
      };
    }
  }]);

  return ActiveItem;
}(PIXI.Container);

exports.default = ActiveItem;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Events = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SwitchAngel = function (_PIXI$Container) {
  _inherits(SwitchAngel, _PIXI$Container);

  function SwitchAngel() {
    _classCallCheck(this, SwitchAngel);

    // const
    var _this = _possibleConstructorReturn(this, (SwitchAngel.__proto__ || Object.getPrototypeOf(SwitchAngel)).call(this));

    _this.ARROW = {
      HIDDEN: {
        X: 42,
        Y: -5
      },
      OVER: {
        X: 49,
        Y: -28
      },
      OUT: {
        X: 52,
        Y: -53
      }
    };
    _this.POSITION = {
      X: 654,
      Y: 86
    };
    _this.DIFFERENCE = {
      X: 2,
      Y: 1
    };

    // parts
    _this.angel = null;
    _this.angelHover = null;
    _this.arrow = null;

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(SwitchAngel, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      // parts
      this.angel = new PIXI.Sprite.fromFrame('andel-0.png');
      this.addChild(this.angel);

      this.angelHover = new PIXI.Sprite.fromFrame('andel-1.png');
      this.angelHover.visible = false;
      this.addChild(this.angelHover);

      this.arrow = new PIXI.Sprite.fromFrame('andel-arrow.png');
      this.arrow.alpha = 0;
      this.addChild(this.arrow);

      // interactivity
      this.hitArea = new PIXI.Rectangle(0, 0, 91, 87);
      this.interactive = true;
      this.buttonMode = true;
      this.on('pointerdown', function () {
        _this2.switchClick();
      });
      this.on('pointerover', function () {
        _this2.hoverAnim(true);
      });
      this.on('pointerout', function () {
        _this2.hoverAnim(false);
      });

      // loop
      aScene.signals.loopCall.add(this.loopUp, this);
    }
  }, {
    key: 'switchClick',
    value: function switchClick() {
      if (aScene.sceneManager.sceneState === 0) {
        aScene.signals.sceneCallMain.dispatch(_Events.EVENTS.MOVE_TO_HEAVEN_START);
        aPage.stats.trackEvent('Andel-nahoru');
      }
    }

    // --------------------------------------------------------------
    // Hover
    // --------------------------------------------------------------

  }, {
    key: 'hoverAnim',
    value: function hoverAnim(doHover) {
      TweenMax.killTweensOf(this.arrow);
      if (doHover) {
        this.angel.visible = false;
        this.angelHover.visible = true;
        this.arrow.x = this.ARROW.HIDDEN.X;
        this.arrow.y = this.ARROW.HIDDEN.Y;
        this.arrow.alpha = 0;
        TweenMax.to(this.arrow, 0.8, {
          x: this.ARROW.OVER.X,
          y: this.ARROW.OVER.Y,
          alpha: 1,
          ease: Back.easeOut
        });
        aScene.sndManager.playItemSfx('andel');
      } else {
        this.angel.visible = true;
        this.angelHover.visible = false;
        TweenMax.to(this.arrow, 0.4, {
          x: this.ARROW.OUT.X,
          y: this.ARROW.OUT.Y,
          alpha: 0,
          ease: Sine.easeIn
        });
      }
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      if (aScene.sceneManager.sceneState !== 1) {
        this.x = this.POSITION.X - this.DIFFERENCE.X * aScene.iManager.stageRatio.half.x;
        this.y = this.POSITION.Y - this.DIFFERENCE.Y * aScene.iManager.stageRatio.half.y;
      }
    }
  }]);

  return SwitchAngel;
}(PIXI.Container);

exports.default = SwitchAngel;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SmokeParticle = __webpack_require__(36);

var _SmokeParticle2 = _interopRequireDefault(_SmokeParticle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SmokeStream = function (_PIXI$Container) {
  _inherits(SmokeStream, _PIXI$Container);

  function SmokeStream(pX, pY, baseAlpha, strength) {
    _classCallCheck(this, SmokeStream);

    // vars
    var _this = _possibleConstructorReturn(this, (SmokeStream.__proto__ || Object.getPrototypeOf(SmokeStream)).call(this));

    _this.pX = pX;
    _this.pY = pY;
    _this.baseAlpha = baseAlpha;
    _this.strength = strength;
    _this.puffs = [];

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(SmokeStream, [{
    key: 'init',
    value: function init() {
      // props
      this.x = this.pX;
      this.y = this.pY;

      // puffs
      for (var i = 0; i < this.strength; i += 1) {
        this.puffs.push(new _SmokeParticle2.default(this, 260, this.baseAlpha));
      }

      // loop
      aScene.signals.loopCall.add(this.loopUp, this);
      // init update
      this.loopUp();
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      if (aScene.sceneManager.sceneState !== 1) {
        for (var i = 0; i < this.puffs.length; i += 1) {
          this.puffs[i].lUp();
        }
      }
    }
  }]);

  return SmokeStream;
}(PIXI.Container);

exports.default = SmokeStream;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SmokeParticle = function () {
  function SmokeParticle(pCont, maxH, iAlpha) {
    _classCallCheck(this, SmokeParticle);

    // const
    this.pCont = pCont;
    this.maxH = -maxH;
    this.iAlpha = iAlpha;

    // parts
    this.ptc = null;

    // vars
    this.vX = 0.0;
    this.vY = 0.0;
    this.vS = 0.0;
    this.vR = 0.0;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(SmokeParticle, [{
    key: "init",
    value: function init() {
      this.ptc = new PIXI.Sprite.fromFrame("p-smoke-" + (1 + Math.round(Math.random() * 2)) + ".png");
      this.ptc.anchor.x = 0.5;
      this.ptc.anchor.y = 0.5;
      this.pCont.addChild(this.ptc);

      // init setup
      this.resetPt();

      // set init random y
      this.ptc.y = Math.random() * this.maxH;
      var posValue = -this.ptc.y / this.vY;

      this.ptc.x -= this.vX * posValue;
      this.ptc.scale.x += this.vS * posValue;
      this.ptc.scale.y = this.ptc.scale.x;
    }

    // --------------------------------------------------------------
    // Reset
    // --------------------------------------------------------------

  }, {
    key: "resetPt",
    value: function resetPt() {
      this.ptc.x = 0;
      this.ptc.y = 0;
      this.ptc.rotation = Math.random() * Math.PI * 2;
      this.ptc.alpha = this.iAlpha;
      this.ptc.scale.x = 0.2;
      this.ptc.scale.y = 0.2;
      this.vX = (-0.02 + Math.random() * 0.1) * 0.5;
      this.vY = 0.09 + Math.random() * 0.09;
      this.vS = (0.0007 + Math.random() * 0.0003) * 0.5;
      this.vR = -0.01 + Math.random() * 0.02;
    }

    // --------------------------------------------------------------
    // Update
    // --------------------------------------------------------------

  }, {
    key: "lUp",
    value: function lUp() {
      this.ptc.x -= this.vX;
      this.ptc.y -= this.vY;
      this.ptc.rotation += this.vR;
      this.ptc.alpha = this.iAlpha * (1 - this.ptc.y / this.maxH);

      this.ptc.scale.x += this.vS;
      this.ptc.scale.y = this.ptc.scale.x;

      if (this.ptc.y < this.maxH) {
        this.resetPt();
      }
    }
  }]);

  return SmokeParticle;
}();

exports.default = SmokeParticle;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Events = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SnowOverlay = function (_PIXI$Sprite) {
  _inherits(SnowOverlay, _PIXI$Sprite);

  function SnowOverlay(texture) {
    _classCallCheck(this, SnowOverlay);

    // vars


    // init
    var _this = _possibleConstructorReturn(this, (SnowOverlay.__proto__ || Object.getPrototypeOf(SnowOverlay)).call(this, texture));

    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(SnowOverlay, [{
    key: 'init',
    value: function init() {
      // props
      this.visible = false;

      // signals
      aScene.signals.sceneCallMain.add(this.callMainFc, this);
    }

    // --------------------------------------------------------------
    // Show/Hide
    // --------------------------------------------------------------

  }, {
    key: 'showOverlay',
    value: function showOverlay() {
      TweenMax.killTweensOf(this);
      this.visible = true;
      this.alpha = 1;
      // hide with delay
      TweenMax.to(this, 3.0, {
        alpha: 0.0,
        delay: 20,
        onComplete: this.hideOverlayEnd,
        onCompleteScope: this
      });
    }
  }, {
    key: 'hideOverlayEnd',
    value: function hideOverlayEnd() {
      this.visible = false;
    }

    // --------------------------------------------------------------
    // Main Call
    // --------------------------------------------------------------

  }, {
    key: 'callMainFc',
    value: function callMainFc(sgType) {
      switch (sgType) {
        case _Events.EVENTS.MOVE_TO_TOWN_START:
          if (aScene.sceneManager.snowMain > 0.8) {
            this.showOverlay();
          }
          break;
        default:
      }
    }
  }]);

  return SnowOverlay;
}(PIXI.Sprite);

exports.default = SnowOverlay;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

var _ItemBullet = __webpack_require__(39);

var _ItemBullet2 = _interopRequireDefault(_ItemBullet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BulletLayer = function (_PIXI$Container) {
  _inherits(BulletLayer, _PIXI$Container);

  function BulletLayer(layerId) {
    _classCallCheck(this, BulletLayer);

    // vars
    var _this = _possibleConstructorReturn(this, (BulletLayer.__proto__ || Object.getPrototypeOf(BulletLayer)).call(this));

    _this.layerId = layerId;

    // move
    _this.diff = [0, 0];

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(BulletLayer, [{
    key: 'init',
    value: function init() {
      // vars
      this.diff = _ConfigScene2.default.MOVE_DIFF_BULLETS[this.layerId];

      // bullets
      this.setBullets();

      // add loop
      aScene.signals.loopCall.add(this.loopUp, this);
    }

    // --------------------------------------------------------------
    // Bullets
    // --------------------------------------------------------------

  }, {
    key: 'setBullets',
    value: function setBullets() {
      // get data
      var imsData = aScene.dataPool.town['lr-' + this.layerId];

      // set bullets
      for (var i = 0; i < imsData.length; i += 1) {
        if (this.mikulasCheck(imsData[i].id)) {
          this.addChild(new _ItemBullet2.default(imsData[i]));
        }
      }
    }
  }, {
    key: 'mikulasCheck',
    value: function mikulasCheck(itemId) {
      return aPage.mikulas && itemId.indexOf('nomik') === -1 || !aPage.mikulas && itemId.indexOf('mikulas') === -1;
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      if (aScene.sceneManager.sceneState !== 1) {
        this.x = this.diff[0] * aScene.iManager.stageRatio.half.x;
        this.y = this.diff[1] * aScene.iManager.stageRatio.half.y;
      }
    }
  }]);

  return BulletLayer;
}(PIXI.Container);

exports.default = BulletLayer;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemBullet = function (_PIXI$Container) {
  _inherits(ItemBullet, _PIXI$Container);

  function ItemBullet(bllData) {
    _classCallCheck(this, ItemBullet);

    // const
    var _this = _possibleConstructorReturn(this, (ItemBullet.__proto__ || Object.getPrototypeOf(ItemBullet)).call(this));

    _this.LBL_TX_X = 23;
    _this.LBL_TX_PAD_X = 16;
    _this.LBL_W = 400;

    // vars
    _this.hovered = false;
    _this.bulletEnabled = false;
    _this.isLeft = false; // label open type

    _this.bllData = bllData;
    _this.bllId = Number(_this.bllData.id.split('_')[0]);
    _this.hideGoal = 0;

    _this.lblCont = null;
    _this.lblBg = null;
    _this.lblTx = null;
    _this.lblMask = null;

    _this.bllCont = null;
    _this.bllBg = null;
    _this.bllNum = null;

    _this.initAnimDelay = null;

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(ItemBullet, [{
    key: 'init',
    value: function init() {
      // props
      this.visible = false;
      this.x = this.bllData.iX + this.bllData.hint.hX;
      this.y = this.bllData.iY + this.bllData.hint.hY;

      if (this.x > 1100) {
        this.isLeft = true;
      }

      // parts
      this.setParts();

      // anim
      this.initAnim();

      // lsns
      aScene.signals.itemCall.add(this.itemCallFc, this);
    }

    // --------------------------------------------------------------
    // Init anim
    // --------------------------------------------------------------

  }, {
    key: 'initAnim',
    value: function initAnim() {
      var _this2 = this;

      // show with delay
      this.initAnimDelay = setTimeout(function () {
        _this2.initAnimStart();
      }, 800 + this.bllId * 100);
    }
  }, {
    key: 'initAnimSkip',
    value: function initAnimSkip() {
      clearTimeout(this.initAnimDelay);
    }
  }, {
    key: 'initAnimStart',
    value: function initAnimStart() {
      var _this3 = this;

      this.showBullet(true);
      // hide with delay
      this.initAnimDelay = setTimeout(function () {
        _this3.initAnimEnd();
      }, 3000);
    }
  }, {
    key: 'initAnimEnd',
    value: function initAnimEnd() {
      this.showBullet(false);
    }

    // --------------------------------------------------------------
    // Set parts
    // --------------------------------------------------------------

  }, {
    key: 'setParts',
    value: function setParts() {
      this.setLabel();
      this.setBullet();
    }

    // --------------------------------------------------------------
    // Label
    // --------------------------------------------------------------

  }, {
    key: 'setLabel',
    value: function setLabel() {
      this.lblCont = new PIXI.Container();
      this.lblCont.visible = false;
      this.addChild(this.lblCont);

      this.lblBg = new PIXI.Sprite.fromFrame('hint-tx-bg.png');
      this.lblCont.addChild(this.lblBg);
      this.lblBg.anchor.y = 0.5;

      this.lblTx = new PIXI.Text('', { font: '15px ' + _ConfigScene2.default.FONT_BASE, fill: '#084d54' });
      if (this.isLeft) {
        this.lblTx.x = -this.LBL_TX_X;
        this.lblTx.anchor.x = 1.0;
      } else {
        this.lblTx.x = this.LBL_TX_X;
      }
      this.lblTx.y = -8;
      this.lblCont.addChild(this.lblTx);

      this.lblMask = new PIXI.Graphics();
      this.lblMask.beginFill(0x000000, 1.0);
      if (this.isLeft) {
        this.lblMask.drawRect(-this.LBL_W, -17, this.LBL_W, 34);
      } else {
        this.lblMask.drawRect(0, -17, this.LBL_W, 34);
      }
      this.lblMask.endFill();
      this.addChild(this.lblMask);
      this.lblCont.mask = this.lblMask;

      this.setLabelTx(aScene.daysInfoArr[this.bllId].title1);
      if (!aPage.features.isAppOpen(aScene.daysInfoArr[this.bllId])) {
        this.setLabelTx(aScene.daysInfoArr[this.bllId].alt.title1);
      }
    }
  }, {
    key: 'setLabelTx',
    value: function setLabelTx(txt) {
      // set
      this.lblTx.text = txt.replace(/\n/g, ' ');
      this.lblTx.updateText();
      // update elements
      if (this.isLeft) {
        this.lblBg.x = -this.lblTx.width - this.LBL_TX_X - this.LBL_TX_PAD_X;
      } else {
        this.lblBg.x = -this.LBL_W + this.lblTx.width + this.LBL_TX_X + this.LBL_TX_PAD_X;
      }
      // anim value
      this.hideGoal = this.lblTx.width + this.LBL_TX_X + this.LBL_TX_PAD_X;
      if (!this.isLeft) {
        this.hideGoal *= -1;
      }
    }
  }, {
    key: 'showLabel',
    value: function showLabel(doShow) {
      if (doShow) {
        // show
        this.lblCont.visible = true;
        this.killLabelAnim();

        this.lblCont.x = this.hideGoal;
        this.lblCont.alpha = 0.0;
        TweenMax.to(this.lblCont, 0.25, {
          x: 0,
          alpha: 1.0,
          delay: 0.1,
          ease: Sine.easeOut
        });
      } else {
        // hide
        this.killLabelAnim();
        TweenMax.to(this.lblCont, 0.2, {
          x: this.hideGoal,
          alpha: 0.0,
          ease: Sine.easeIn,
          onComplete: this.labelAnimEnd,
          onCompleteScope: this
        });
      }
    }
  }, {
    key: 'killLabelAnim',
    value: function killLabelAnim() {
      TweenMax.killTweensOf(this.lblCont);
    }
  }, {
    key: 'labelAnimEnd',
    value: function labelAnimEnd() {
      this.lblCont.visible = false;
    }

    // --------------------------------------------------------------
    // Bullet
    // --------------------------------------------------------------

  }, {
    key: 'setBullet',
    value: function setBullet() {
      var _this4 = this;

      this.bllCont = new PIXI.Container();
      this.addChild(this.bllCont);

      this.bllBg = new PIXI.Sprite.fromFrame('hint-blt-bg.png');
      this.bllCont.addChild(this.bllBg);
      this.bllBg.anchor.x = 0.5;
      this.bllBg.anchor.y = 0.5;

      this.bllNum = new PIXI.Text(String(this.bllId + 1), {
        font: '16px ' + _ConfigScene2.default.FONT_BASE,
        fill: '#ffffff'
      });
      this.bllNum.anchor.x = 0.5;
      this.bllNum.anchor.y = 0.5;
      this.bllCont.addChild(this.bllNum);

      // touch interactivity
      if (aPage.features.isTouch) {
        this.interactive = true;
        this.on('pointerdown', function () {
          if (_this4.hovered) {
            aScene.itemsHelper.trySelectItem();
          }
        });
      }
    }
  }, {
    key: 'showBullet',
    value: function showBullet(doShow) {
      if (doShow && !this.bulletEnabled) {
        // show
        this.bulletEnabled = true;
        this.visible = true;
        this.killBulletAnim();

        this.bllCont.alpha = 0.0;
        TweenMax.to(this.bllCont, 0.3, { alpha: 1.0 });

        this.bllCont.scale.x = 0.4;
        this.bllCont.scale.y = 0.4;
        TweenMax.to(this.bllCont.scale, 0.3, { x: 1.0, y: 1.0, ease: Back.easeOut });
      } else if (!doShow && this.bulletEnabled && !aScene.itemsHelper.helpBullets) {
        this.bulletEnabled = false;
        // hide
        this.killBulletAnim();
        TweenMax.to(this.bllCont, 0.2, { alpha: 0.0, delay: 0.1 });
        TweenMax.to(this.bllCont.scale, 0.2, {
          x: 0.2,
          y: 0.2,
          delay: 0.1,
          ease: Sine.easeIn,
          onComplete: this.bulletAnimEnd,
          onCompleteScope: this
        });
      }
    }
  }, {
    key: 'killBulletAnim',
    value: function killBulletAnim() {
      TweenMax.killTweensOf(this.bllCont);
      TweenMax.killTweensOf(this.bllCont.scale);
    }
  }, {
    key: 'bulletAnimEnd',
    value: function bulletAnimEnd() {
      this.visible = false;
    }

    // --------------------------------------------------------------
    // Lsn
    // --------------------------------------------------------------

  }, {
    key: 'itemCallFc',
    value: function itemCallFc(sgType, optParams) {
      switch (sgType) {
        case _ConfigScene2.default.E_ITEM_BULLET_SWITCH:
          this.initAnimSkip();
          this.showBullet(aScene.itemsHelper.helpBullets);
          break;
        case _ConfigScene2.default.E_ITEM_HOVER:
          if (!aPage.isArchive) {
            if (optParams === this.bllId) {
              this.setHoverState(true);
            } else {
              this.setHoverState(false);
            }
          }
          break;
        default:
      }
    }

    // --------------------------------------------------------------
    // Show/Hide
    // --------------------------------------------------------------

  }, {
    key: 'setHoverState',
    value: function setHoverState(doHover) {
      if (doHover && !this.hovered) {
        this.doHover(true);
      } else if (!doHover && this.hovered) {
        this.doHover(false);
      }
    }
  }, {
    key: 'doHover',
    value: function doHover(hover) {
      this.hovered = hover;
      this.initAnimSkip();
      this.showBullet(hover);
      this.showLabel(hover);
    }
  }]);

  return ItemBullet;
}(PIXI.Container);

exports.default = ItemBullet;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Clock = function () {
  function Clock() {
    _classCallCheck(this, Clock);

    // vars
    this.checkInterval = null;
    this.resetCheck = false;
    this.checkDate = null;

    this.clockTimer = null;
    this.quarters = 0;
    this.hours = 0;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(Clock, [{
    key: 'init',
    value: function init() {
      this.startCheck();
    }

    // --------------------------------------------------------------
    // Check
    // --------------------------------------------------------------

  }, {
    key: 'startCheck',
    value: function startCheck() {
      var _this = this;

      this.checkInterval = setInterval(function () {
        _this.timeCheck();
      }, 10000);
    }
  }, {
    key: 'timeCheck',
    value: function timeCheck() {
      var _this2 = this;

      this.checkDate = new Date();
      switch (this.checkDate.getMinutes()) {
        case 0:
          this.resetCheck = true;
          this.playSound(4, this.getHour());
          break;
        case 15:
          this.resetCheck = true;
          this.playSound(1, 0);
          break;
        case 30:
          this.resetCheck = true;
          this.playSound(2, 0);
          break;
        case 45:
          this.resetCheck = true;
          this.playSound(3, 0);
          break;
        default:
          this.resetCheck = false;
      }
      // try reset
      if (this.resetCheck) {
        clearInterval(this.checkInterval);
        // restart after ten minutes
        setTimeout(function () {
          _this2.startCheck();
        }, 1000 * 60 * 10);
      }
    }
  }, {
    key: 'getHour',
    value: function getHour() {
      var hour = this.checkDate.getHours() % 12;
      if (hour !== 0) {
        return hour;
      }
      return 12;
    }

    // --------------------------------------------------------------
    // Play
    // --------------------------------------------------------------

  }, {
    key: 'playSound',
    value: function playSound(quarters, hours) {
      this.quarters = quarters;
      this.hours = hours;
      clearInterval(this.clockTimer);
      this.tryQuarter();
      aPage.stats.trackEvent('Hodiny', quarters + '-' + hours);
    }
  }, {
    key: 'tryQuarter',
    value: function tryQuarter() {
      var _this3 = this;

      if (this.quarters > 0) {
        this.quarters -= 1;
        if (aScene.sndManager.ambiActive) {
          aScene.sndManager.playSfx('hodiny-30');
        }
        this.clockTimer = setTimeout(function () {
          _this3.tryQuarter();
        }, 2200);
      } else {
        this.tryHour();
      }
    }
  }, {
    key: 'tryHour',
    value: function tryHour() {
      var _this4 = this;

      if (this.hours > 0) {
        this.hours -= 1;
        if (aScene.sndManager.ambiActive) {
          aScene.sndManager.playSfx('hodiny-12');
        }
        this.clockTimer = setTimeout(function () {
          _this4.tryHour();
        }, 2200);
      }
    }
  }]);

  return Clock;
}();

exports.default = Clock;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TransCloud = __webpack_require__(42);

var _TransCloud2 = _interopRequireDefault(_TransCloud);

var _Events = __webpack_require__(1);

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Transition = function (_PIXI$Container) {
  _inherits(Transition, _PIXI$Container);

  function Transition() {
    _classCallCheck(this, Transition);

    // vars
    var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this));

    _this.clouds = [];

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(Transition, [{
    key: 'init',
    value: function init() {
      // props
      this.y = _ConfigScene2.default.SIZES.SCENE_ACTIVE_HEIGHT;
      this.visible = false;

      // items
      this.setItems();

      // add loop
      aScene.signals.loopCall.add(this.loopUp, this);
      aScene.signals.sceneCallMain.add(this.callMainFc, this);
    }

    // --------------------------------------------------------------
    // Main Call
    // --------------------------------------------------------------

  }, {
    key: 'callMainFc',
    value: function callMainFc(sgType) {
      switch (sgType) {
        case _Events.EVENTS.MOVE_TO_TOWN_END:
        case _Events.EVENTS.MOVE_TO_HEAVEN_END:
          this.visible = false;
          break;
        case _Events.EVENTS.MOVE_TO_TOWN_START:
        case _Events.EVENTS.MOVE_TO_HEAVEN_START:
          this.visible = true;
          break;
        default:
      }
    }

    // --------------------------------------------------------------
    // Items
    // --------------------------------------------------------------

  }, {
    key: 'setItems',
    value: function setItems() {
      var _this2 = this;

      this.clouds = aScene.dataPool.transition.clouds.map(function (data) {
        return new _TransCloud2.default(_this2, data);
      });
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      if (aScene.sceneManager.sceneState === -1) {
        this.clouds.forEach(function (cloud) {
          return cloud.loopUp();
        });
      }
    }
  }]);

  return Transition;
}(PIXI.Container);

exports.default = Transition;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TransCloud = function () {
  function TransCloud(parentCont, data) {
    _classCallCheck(this, TransCloud);

    // const
    this.Z_MAX = 500;

    // vars
    this.parentCont = parentCont;
    this.data = data;
    this.cloudId = this.data.id.split('_')[0].replace('c', '');
    this.position = {
      z: this.Z_MAX * (this.data.id.split('_')[1] / 100),
      base: {
        x: this.data.iX,
        y: this.data.iY
      }
    };

    // parts
    this.sprite = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(TransCloud, [{
    key: 'init',
    value: function init() {
      this.sprite = new PIXI.Sprite.fromFrame('cloud-' + this.cloudId + '.png');
      this.parentCont.addChild(this.sprite);
      this.sprite.anchor.x = 0.5;
      this.sprite.anchor.y = 0.5;
      this.sprite.scale.x = this.data.sX;
      this.sprite.scale.y = this.data.sY;
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      this.sprite.x = this.position.base.x;
      this.sprite.y = this.position.base.y + this.position.z * aScene.sceneManager.offsetProgress;
    }
  }]);

  return TransCloud;
}();

exports.default = TransCloud;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SwitchBack = __webpack_require__(44);

var _SwitchBack2 = _interopRequireDefault(_SwitchBack);

var _HiAngel = __webpack_require__(45);

var _HiAngel2 = _interopRequireDefault(_HiAngel);

var _HiCloud = __webpack_require__(48);

var _HiCloud2 = _interopRequireDefault(_HiCloud);

var _HiGod = __webpack_require__(49);

var _HiGod2 = _interopRequireDefault(_HiGod);

var _Events = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Heaven = function (_PIXI$Container) {
  _inherits(Heaven, _PIXI$Container);

  function Heaven() {
    _classCallCheck(this, Heaven);

    // vars
    var _this = _possibleConstructorReturn(this, (Heaven.__proto__ || Object.getPrototypeOf(Heaven)).call(this));

    _this.items = [];

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(Heaven, [{
    key: 'init',
    value: function init() {
      // items
      this.setItems();

      // signals
      aScene.signals.loopCall.add(this.loopUp, this);
      aScene.signals.sceneCallMain.add(this.callMainFc, this);
    }

    // --------------------------------------------------------------
    // Main Call
    // --------------------------------------------------------------

  }, {
    key: 'callMainFc',
    value: function callMainFc(sgType) {
      switch (sgType) {
        case _Events.EVENTS.MOVE_TO_TOWN_END:
          this.visible = false;
          this.items.forEach(function (item) {
            return item.floatStop();
          });
          break;
        case _Events.EVENTS.MOVE_TO_HEAVEN_START:
          this.visible = true;
          this.items.forEach(function (item) {
            return item.floatStart();
          });
          break;
        default:
      }
    }

    // --------------------------------------------------------------
    // Items
    // --------------------------------------------------------------

  }, {
    key: 'setItems',
    value: function setItems() {
      var _this2 = this;

      this.items = aScene.dataPool.heaven.items.map(function (item) {
        if (item.type.charAt(0) === 'a') {
          return new _HiAngel2.default(_this2, item);
        } else if (item.type.charAt(0) === 'c') {
          return new _HiCloud2.default(_this2, item);
        } else if (item.type.indexOf('god') !== -1) {
          return new _HiGod2.default(_this2, item);
        }
        return null;
      });

      // switch
      this.addChild(new _SwitchBack2.default());
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      if (aScene.sceneManager.sceneState !== 0) {
        this.items.forEach(function (item) {
          return item.loopUp();
        });
      }
    }
  }]);

  return Heaven;
}(PIXI.Container);

exports.default = Heaven;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Events = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SwitchBack = function (_PIXI$Container) {
  _inherits(SwitchBack, _PIXI$Container);

  function SwitchBack() {
    _classCallCheck(this, SwitchBack);

    // const
    var _this = _possibleConstructorReturn(this, (SwitchBack.__proto__ || Object.getPrototypeOf(SwitchBack)).call(this));

    _this.ALPHA = 0.6;
    _this.POSITION = {
      X: 695,
      Y: 485
    };
    _this.DIFFERENCE = {
      X: 7,
      Y: 6
    };

    // parts
    _this.arrow = null;

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(SwitchBack, [{
    key: 'init',
    value: function init() {
      var _this2 = this;

      // props
      this.alpha = this.ALPHA;

      // parts
      this.arrow = new PIXI.Sprite.fromFrame('arrow-down.png');
      this.addChild(this.arrow);

      // interactivity
      this.hitArea = new PIXI.Rectangle(0, 0, 30, 63);
      this.interactive = true;
      this.buttonMode = true;
      this.on('pointerdown', function () {
        _this2.switchClick();
      });
      this.on('pointerover', function () {
        _this2.hoverAnim(true);
      });
      this.on('pointerout', function () {
        _this2.hoverAnim(false);
      });

      // loop
      aScene.signals.loopCall.add(this.loopUp, this);
    }
  }, {
    key: 'switchClick',
    value: function switchClick() {
      if (aScene.sceneManager.sceneState === 1) {
        aScene.signals.sceneCallMain.dispatch(_Events.EVENTS.MOVE_TO_TOWN_START);
        aPage.stats.trackEvent('Andel-dolu');
      }
    }

    // --------------------------------------------------------------
    // Hover
    // --------------------------------------------------------------

  }, {
    key: 'hoverAnim',
    value: function hoverAnim(doHover) {
      TweenMax.killTweensOf(this);
      TweenMax.killTweensOf(this.arrow);
      if (doHover) {
        TweenMax.to(this, 0.2, {
          alpha: 1
        });
        TweenMax.to(this.arrow, 0.4, {
          y: -15,
          ease: Sine.easeInOut,
          onComplete: this.hoverBack,
          onCompleteScope: this
        });
      } else {
        TweenMax.to(this, 0.2, {
          alpha: this.ALPHA
        });
      }
    }
  }, {
    key: 'hoverBack',
    value: function hoverBack() {
      TweenMax.to(this.arrow, 0.5, {
        y: 0,
        ease: Sine.easeInOut
      });
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      if (aScene.sceneManager.sceneState !== 0) {
        this.x = this.POSITION.X - this.DIFFERENCE.X * aScene.iManager.stageRatio.half.x;
        this.y = this.POSITION.Y - this.DIFFERENCE.Y * aScene.iManager.stageRatio.half.y;
      }
    }
  }]);

  return SwitchBack;
}(PIXI.Container);

exports.default = SwitchBack;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _HeavenItem2 = __webpack_require__(3);

var _HeavenItem3 = _interopRequireDefault(_HeavenItem2);

var _ConfigScene = __webpack_require__(0);

var _HiAngelPart = __webpack_require__(46);

var _HiAngelPart2 = _interopRequireDefault(_HiAngelPart);

var _AngelSnowParticle = __webpack_require__(47);

var _AngelSnowParticle2 = _interopRequireDefault(_AngelSnowParticle);

var _Events = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HiAngel = function (_HeavenItem) {
  _inherits(HiAngel, _HeavenItem);

  function HiAngel(parentCont, data) {
    _classCallCheck(this, HiAngel);

    // const
    var _this = _possibleConstructorReturn(this, (HiAngel.__proto__ || Object.getPrototypeOf(HiAngel)).call(this, data));

    _this.SNOW_CEIL = aPage.features.isCanvas ? 750 : 1500;
    _this.SNOW_MAX = aPage.features.isCanvas ? 500 : 1000;
    _this.SNOW_MIN = aPage.features.isCanvas ? 50 : 100;

    _this.SNOW_DIFF = _this.SNOW_MAX - _this.SNOW_MIN;

    _this.DELAY_MAX = aPage.features.isCanvas ? 400 : 200;
    _this.DELAY_MIN = aPage.features.isCanvas ? 50 : 25;
    _this.DELAY_DIFF = _this.DELAY_MAX - _this.DELAY_MIN;

    // vars snow
    _this.flakeLast = 0;
    _this.flakeDelay = 0;
    _this.flakesActive = [];
    _this.flakesPool = [];

    // vars
    _this.parentCont = parentCont;
    _this.angelId = Number(_this.data.type.split('_')[0].replace('a', ''));
    _this.angelData = _ConfigScene.ANGELS['a' + _this.angelId];
    _this.angelParts = [];
    _this.flakes = [];

    // animation
    _this.frameActual = 0;
    _this.frameTotal = _this.angelData.anim[_this.angelData.parts[0].replace('.png', '')].length;
    _this.animTimer = null;
    _this.ANIM_STEP = 41.667;

    // parts
    _this.mainCont = null;
    _this.snow = null;
    _this.angel = null;

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(HiAngel, [{
    key: 'init',
    value: function init() {
      // vars
      aScene.sceneManager.snowAngels.push(0);

      // parts
      this.mainCont = new PIXI.Container();
      this.parentCont.addChild(this.mainCont);
      this.setSnow();
      this.setAngel();

      // signals
      aScene.signals.sceneCallMain.add(this.callMainFc, this);
    }

    // --------------------------------------------------------------
    // Main Call
    // --------------------------------------------------------------

  }, {
    key: 'callMainFc',
    value: function callMainFc(sgType) {
      switch (sgType) {
        case _Events.EVENTS.MOVE_TO_HEAVEN_START:
          // reset flakes + value to average
          aScene.sceneManager.snowAngels[this.angelId] = aScene.sceneManager.snowMain;
          this.resetFlakes();
          break;
        default:
      }
    }

    // --------------------------------------------------------------
    // Snow
    // --------------------------------------------------------------

  }, {
    key: 'setSnow',
    value: function setSnow() {
      // set container
      this.snow = new PIXI.ParticleContainer(this.SNOW_CEIL, {
        scale: true,
        position: true,
        rotation: false,
        uvs: false,
        alpha: true
      });
      this.snow.x = this.angelData.snow.x;
      this.snow.y = this.angelData.snow.y;
      this.mainCont.addChildAt(this.snow, 0);
    }
  }, {
    key: 'addFlake',
    value: function addFlake(randomY) {
      var flake = null;
      if (this.flakesPool.length > 0) {
        flake = this.flakesPool.pop();
      } else {
        flake = new _AngelSnowParticle2.default(this.snow, this.angelData.snow.w);
      }
      flake.reset(randomY);
      this.flakesActive.push(flake);
    }
  }, {
    key: 'resetFlakes',
    value: function resetFlakes() {
      var _this2 = this;

      // reset current
      this.flakesActive.forEach(function (flake) {
        flake.remove();
        _this2.flakesPool.push(flake);
      });
      this.flakesActive = [];
      // set
      for (var i = 0; i < Math.round(this.SNOW_MIN + this.SNOW_DIFF * aScene.sceneManager.snowAngels[this.angelId]); i += 1) {
        this.addFlake(true);
      }
    }
  }, {
    key: 'flakesWave',
    value: function flakesWave() {
      var angelValue = aScene.sceneManager.snowAngels[this.angelId];
      if (angelValue < 1) {
        aScene.sceneManager.snowAngels[this.angelId] = Math.min(angelValue + 0.5, 1);
        var waveLimit = aPage.features.isCanvas ? 40 : 80;
        for (var i = 0; i < waveLimit; i += 1) {
          this.addFlake(false);
        }
      }
      aScene.sceneManager.snowUpdate();
    }
  }, {
    key: 'moveFlakes',
    value: function moveFlakes() {
      var _this3 = this;

      var movingFlakes = [];
      this.flakesActive.forEach(function (flake) {
        if (flake.lUp()) {
          movingFlakes.push(flake);
        } else {
          _this3.flakesPool.push(flake);
        }
      });
      this.flakesActive = movingFlakes;
    }
  }, {
    key: 'addFlakes',
    value: function addFlakes() {
      this.flakeLast += aScene.sceneManager.msFrame;
      this.flakeDelay = this.DELAY_MAX - this.DELAY_DIFF * aScene.sceneManager.snowAngels[this.angelId];
      while (this.flakeLast > this.flakeDelay) {
        this.flakeLast -= this.flakeDelay;
        this.addFlake(false);
      }
    }

    // --------------------------------------------------------------
    // Angel parts
    // --------------------------------------------------------------

  }, {
    key: 'setAngel',
    value: function setAngel() {
      var _this4 = this;

      this.angel = new PIXI.Container();
      this.mainCont.addChild(this.angel);
      for (var i = 0; i < this.angelData.parts.length; i += 1) {
        var partId = this.angelData.parts[i];
        this.angelParts.push(new _HiAngelPart2.default(this.angel, partId, this.angelData.anim[partId.replace('.png', '')]));
      }

      // interactivity
      this.angel.interactive = true;
      this.angel.buttonMode = true;
      this.angel.on('pointerdown', function () {
        _this4.playAnim();
      });
    }
  }, {
    key: 'playAnim',
    value: function playAnim() {
      var _this5 = this;

      if (this.frameActual === 0) {
        this.animTimer = setInterval(function () {
          _this5.animStep();
        }, this.ANIM_STEP);
        aScene.sndManager.playSfx('angels/a-' + this.angelId);
        setTimeout(function () {
          _this5.flakesWave();
        }, this.angelData.snow.delay);
      }
    }
  }, {
    key: 'animStep',
    value: function animStep() {
      this.frameActual += 1;
      if (this.frameActual === this.frameTotal) {
        // end
        clearInterval(this.animTimer);
        this.frameActual = 0;
      }
      this.animUpdate();
    }
  }, {
    key: 'animUpdate',
    value: function animUpdate() {
      var _this6 = this;

      this.angelParts.forEach(function (part) {
        part.setFrame(_this6.frameActual);
      });
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      _get(HiAngel.prototype.__proto__ || Object.getPrototypeOf(HiAngel.prototype), 'loopUp', this).call(this);
      this.mainCont.x = this.position.item.x;
      this.mainCont.y = this.position.item.y;
      // snow
      this.moveFlakes();
      this.addFlakes();
    }
  }]);

  return HiAngel;
}(_HeavenItem3.default);

exports.default = HiAngel;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HiAngelPart = function () {
  function HiAngelPart(parentCont, id, data) {
    _classCallCheck(this, HiAngelPart);

    this.parentCont = parentCont;
    this.id = id;
    this.partData = data;

    // parts
    this.sprite = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(HiAngelPart, [{
    key: "init",
    value: function init() {
      this.sprite = new PIXI.Sprite.fromFrame(this.id);
      this.parentCont.addChild(this.sprite);

      // init frame
      this.setFrame(0);
    }

    // --------------------------------------------------------------
    // Set Frame
    // --------------------------------------------------------------

  }, {
    key: "setFrame",
    value: function setFrame(frameId) {
      if (this.partData[frameId][0] === 0) {
        // inactive/hidden
        this.sprite.visible = false;
      } else {
        // active
        this.sprite.visible = true;
        this.sprite.x = this.partData[frameId][1];
        this.sprite.y = this.partData[frameId][2];
      }
    }
  }]);

  return HiAngelPart;
}();

exports.default = HiAngelPart;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AngelSnowParticle = function () {
  function AngelSnowParticle(parentCont, maxX) {
    _classCallCheck(this, AngelSnowParticle);

    // const
    this.maxY = 500;
    this.maxX = maxX;
    this.FADE_Y = 100;
    this.FADE_DIFF = this.maxY - this.FADE_Y;

    // props
    this.parentCont = parentCont;

    // vars
    this.tempScale = 1.0;
    this.vX = 0.0;
    this.vY = 0.0;

    // parts
    this.ptc = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(AngelSnowParticle, [{
    key: 'init',
    value: function init() {
      this.ptc = new PIXI.Sprite.fromFrame('p-snow.png');
    }

    // --------------------------------------------------------------
    // Reset
    // --------------------------------------------------------------

  }, {
    key: 'reset',
    value: function reset(randomY) {
      this.parentCont.addChild(this.ptc);
      this.ptc.x = Math.random() * this.maxX;
      this.ptc.alpha = 0.3 + Math.random() * 0.7;
      this.tempScale = 0.5 + Math.random() * 0.5;
      this.ptc.scale.x = this.tempScale;
      this.ptc.scale.y = this.tempScale;
      this.vX = -0.03 + Math.random() * 0.06;
      this.vY = 0.35 + Math.random() * 0.35;

      if (randomY) {
        // random y
        this.ptc.y = Math.random() * this.maxY;
      } else {
        // random top
        this.ptc.y = Math.random() * 10;
      }
    }
  }, {
    key: 'remove',
    value: function remove() {
      this.parentCont.removeChild(this.ptc);
    }

    // --------------------------------------------------------------
    // Update
    // --------------------------------------------------------------

  }, {
    key: 'lUp',
    value: function lUp() {
      this.ptc.x += this.vX;
      this.ptc.y += this.vY;

      if (this.ptc.y > this.maxY) {
        this.remove();
        return false;
      }if (this.ptc.y > this.FADE_DIFF) {
        this.ptc.alpha = (this.maxY - this.ptc.y) / this.FADE_Y;
      }
      return true;
    }
  }]);

  return AngelSnowParticle;
}();

exports.default = AngelSnowParticle;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _HeavenItem2 = __webpack_require__(3);

var _HeavenItem3 = _interopRequireDefault(_HeavenItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HiCloud = function (_HeavenItem) {
  _inherits(HiCloud, _HeavenItem);

  function HiCloud(parentCont, data) {
    _classCallCheck(this, HiCloud);

    // vars
    var _this = _possibleConstructorReturn(this, (HiCloud.__proto__ || Object.getPrototypeOf(HiCloud)).call(this, data));

    _this.parentCont = parentCont;
    // parts
    _this.sprite = null;

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(HiCloud, [{
    key: 'init',
    value: function init() {
      // parts
      this.setSprite(this.data.type.split('_')[0].replace('c', ''));
    }
  }, {
    key: 'setSprite',
    value: function setSprite(spriteId) {
      this.sprite = new PIXI.Sprite.fromFrame('cloud-' + spriteId + '.png');
      this.parentCont.addChild(this.sprite);
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      _get(HiCloud.prototype.__proto__ || Object.getPrototypeOf(HiCloud.prototype), 'loopUp', this).call(this);
      this.sprite.x = this.position.item.x;
      this.sprite.y = this.position.item.y;
    }
  }]);

  return HiCloud;
}(_HeavenItem3.default);

exports.default = HiCloud;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _HeavenItem2 = __webpack_require__(3);

var _HeavenItem3 = _interopRequireDefault(_HeavenItem2);

var _Events = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HiGod = function (_HeavenItem) {
  _inherits(HiGod, _HeavenItem);

  function HiGod(parentCont, data) {
    _classCallCheck(this, HiGod);

    // vars
    var _this = _possibleConstructorReturn(this, (HiGod.__proto__ || Object.getPrototypeOf(HiGod)).call(this, data));

    _this.parentCont = parentCont;
    _this.hideDelay = null;

    _this.inPlaying = false;
    _this.doneIn = false;
    _this.doneOut = false;

    // parts
    _this.sprite = null;

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(HiGod, [{
    key: 'init',
    value: function init() {
      this.sprite = new PIXI.Sprite.fromFrame('god.png');
      this.sprite.anchor.x = 93 / 185;
      this.sprite.anchor.y = 82 / 134;
      this.parentCont.addChild(this.sprite);
      this.sprite.visible = false;

      // signals
      aScene.signals.sceneCallMain.add(this.callMainFc, this);
    }

    // --------------------------------------------------------------
    // Main Call
    // --------------------------------------------------------------

  }, {
    key: 'callMainFc',
    value: function callMainFc(sgType, params) {
      switch (sgType) {
        case _Events.EVENTS.MOVE_TO_HEAVEN_END:
          if (!this.doneIn) {
            this.inPlaying = true;
            this.doneIn = true;
            aScene.sndManager.playSfx('buh-prilet-bez-tonu');
            this.showGod(5000);
          }
          break;
        case _Events.EVENTS.MOVE_TO_TOWN_START:
          if (!this.doneOut && !this.inPlaying) {
            this.doneOut = true;
            aScene.sndManager.stopItemSfx('god');
            aScene.sndManager.playSfx('buh-odlet-' + Math.round(Math.random()) + '-bez-tonu');
            this.showGod(2000);
          }
          break;
        case _Events.EVENTS.SHOW_GOD:
          this.showGod(params);
          break;
        default:
      }
    }

    // --------------------------------------------------------------
    // Show
    // --------------------------------------------------------------

  }, {
    key: 'showGod',
    value: function showGod(hideDelay) {
      var _this2 = this;

      clearTimeout(this.hideDelay);
      TweenMax.killTweensOf(this.sprite);
      TweenMax.killTweensOf(this.sprite.scale);

      this.sprite.alpha = 0;
      this.sprite.visible = true;
      this.sprite.scale.x = 0.3;
      this.sprite.scale.y = 0.2;

      TweenMax.to(this.sprite, 0.4, {
        alpha: 1
      });
      TweenMax.to(this.sprite.scale, 0.5, {
        x: 1,
        y: 1,
        ease: Back.easeOut
      });

      // hide delay
      this.hideDelay = setTimeout(function () {
        _this2.hideGod();
      }, hideDelay);
    }
  }, {
    key: 'hideGod',
    value: function hideGod() {
      this.inPlaying = false;
      TweenMax.to(this.sprite, 0.6, {
        alpha: 0
      });
      TweenMax.to(this.sprite.scale, 0.6, {
        x: 1.4,
        y: 1.4,
        ease: Sine.easeIn,
        onComplete: this.hideEnd,
        onCompleteScope: this
      });
    }
  }, {
    key: 'hideEnd',
    value: function hideEnd() {
      this.sprite.visible = false;
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      _get(HiGod.prototype.__proto__ || Object.getPrototypeOf(HiGod.prototype), 'loopUp', this).call(this);
      this.sprite.x = this.position.item.x;
      this.sprite.y = this.position.item.y;
    }
  }]);

  return HiGod;
}(_HeavenItem3.default);

exports.default = HiGod;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TownSnowParticle = __webpack_require__(51);

var _TownSnowParticle2 = _interopRequireDefault(_TownSnowParticle);

var _Events = __webpack_require__(1);

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TownSnow = function () {
  function TownSnow(parentCont) {
    _classCallCheck(this, TownSnow);

    // const
    this.SNOW_CEIL = aPage.features.isCanvas ? 3000 : 6000;
    this.SNOW_MAX = aPage.features.isCanvas ? 2000 : 4000;
    this.SNOW_MIN = aPage.features.isCanvas ? 200 : 400;
    this.SNOW_DIFF = this.SNOW_MAX - this.SNOW_MIN;

    this.DELAY_MAX = aPage.features.isCanvas ? 180 : 90;
    this.DELAY_MIN = aPage.features.isCanvas ? 18 : 9;
    this.DELAY_DIFF = this.DELAY_MAX - this.DELAY_MIN;

    // vars
    this.parentCont = parentCont;
    this.flakeSpeed = 1;
    this.flakeLast = 0;
    this.flakeDelay = 0;
    this.flakesActive = [];
    this.flakesPool = [];

    // parts
    this.snowCont = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(TownSnow, [{
    key: 'init',
    value: function init() {
      // set container
      this.snowCont = new PIXI.ParticleContainer(this.SNOW_CEIL, {
        scale: true,
        position: true,
        rotation: false,
        uvs: false,
        alpha: true
      });
      this.snowCont.y = -aScene.sceneManager.offset;
      this.parentCont.addChild(this.snowCont);

      // init flakes
      this.resetFlakes();

      // signals
      aScene.signals.loopCall.add(this.loopUp, this);
      aScene.signals.sceneCallMain.add(this.callMainFc, this);
    }

    // --------------------------------------------------------------
    // Main Call
    // --------------------------------------------------------------

  }, {
    key: 'callMainFc',
    value: function callMainFc(sgType) {
      switch (sgType) {
        case _Events.EVENTS.MOVE_TO_HEAVEN_END:
          this.snowCont.visible = false;
          break;
        case _Events.EVENTS.MOVE_TO_TOWN_START:
          this.snowCont.visible = true;
          this.resetFlakes();
          break;
        default:
      }
    }

    // --------------------------------------------------------------
    // Flakes
    // --------------------------------------------------------------

  }, {
    key: 'resetFlakes',
    value: function resetFlakes() {
      var _this = this;

      // reset current
      this.flakesActive.forEach(function (flake) {
        flake.remove();
        _this.flakesPool.push(flake);
      });
      this.flakesActive = [];
      // set
      for (var i = 0; i < Math.round(this.SNOW_MIN + this.SNOW_DIFF * aScene.sceneManager.snowMain); i += 1) {
        this.addFlake(true);
      }
    }
  }, {
    key: 'addFlake',
    value: function addFlake(randomY) {
      var flake = null;
      if (this.flakesPool.length > 0) {
        flake = this.flakesPool.pop();
      } else {
        flake = new _TownSnowParticle2.default(this.snowCont);
      }
      flake.reset(randomY);
      this.flakesActive.push(flake);
    }

    // --------------------------------------------------------------
    // Loop
    // --------------------------------------------------------------

  }, {
    key: 'loopUp',
    value: function loopUp() {
      if (aScene.sceneManager.sceneState !== 1) {
        if (aScene.sceneManager.sceneState === -1) {
          this.transitionUpdate();
        }
        this.moveFlakes();
        this.addFlakes();
      }
    }
  }, {
    key: 'transitionUpdate',
    value: function transitionUpdate() {
      var tempScale = 0.3 * aScene.sceneManager.townScale;
      this.snowCont.scale.x = 1 + tempScale;
      this.snowCont.scale.y = 1 + tempScale;
      this.snowCont.x = -(_ConfigScene2.default.SIZES.SCENE_WIDTH_MAX * tempScale) * 0.5;
      this.snowCont.y = -aScene.sceneManager.offset;
      this.snowCont.alpha = aScene.sceneManager.offsetProgress > 0 ? 0 : Math.abs(aScene.sceneManager.offsetProgress);

      this.flakeSpeed = 1 + 50 * aScene.sceneManager.townScale;
    }
  }, {
    key: 'moveFlakes',
    value: function moveFlakes() {
      var _this2 = this;

      var movingFlakes = [];
      this.flakesActive.forEach(function (flake) {
        if (flake.lUp(_this2.flakeSpeed)) {
          movingFlakes.push(flake);
        } else {
          _this2.flakesPool.push(flake);
        }
      });
      this.flakesActive = movingFlakes;
    }
  }, {
    key: 'addFlakes',
    value: function addFlakes() {
      this.flakeLast += aScene.sceneManager.msFrame;
      this.flakeDelay = (this.DELAY_MAX - this.DELAY_DIFF * aScene.sceneManager.snowMain) / this.flakeSpeed;
      while (this.flakeLast > this.flakeDelay) {
        this.flakeLast -= this.flakeDelay;
        this.addFlake(false);
      }
      if (aScene.sceneManager.sceneState === 0) {
        if (aScene.sceneManager.snowMain > 0) {
          aScene.sceneManager.snowMain -= aScene.sceneManager.msFrame / 40000;
        } else {
          aScene.sceneManager.snowMain = 0;
        }
      }
    }
  }]);

  return TownSnow;
}();

exports.default = TownSnow;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TownSnowParticle = function () {
  function TownSnowParticle(parentCont) {
    _classCallCheck(this, TownSnowParticle);

    // const
    this.MAX_X = _ConfigScene2.default.SIZES.SCENE_WIDTH_MAX;
    this.MAX_Y = 685;

    // props
    this.parentCont = parentCont;

    // vars
    this.tempScale = 1.0;
    this.vX = 0.0;
    this.vY = 0.0;

    // parts
    this.ptc = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(TownSnowParticle, [{
    key: 'init',
    value: function init() {
      this.ptc = new PIXI.Sprite.fromFrame('p-snow.png');
    }

    // --------------------------------------------------------------
    // Reset
    // --------------------------------------------------------------

  }, {
    key: 'reset',
    value: function reset(randomY) {
      this.parentCont.addChild(this.ptc);
      this.ptc.x = Math.random() * this.MAX_X;
      this.ptc.alpha = 0.3 + Math.random() * 0.7;
      this.tempScale = 0.5 + Math.random() * 0.5;
      this.ptc.scale.x = this.tempScale;
      this.ptc.scale.y = this.tempScale;
      this.vX = -0.1 + Math.random() * 0.2;
      this.vY = 0.25 + Math.random() * 0.25;

      if (randomY) {
        // random y
        this.ptc.y = Math.random() * this.MAX_Y;
      } else {
        // random top
        this.ptc.y = -10 - Math.random() * 10;
      }
    }
  }, {
    key: 'remove',
    value: function remove() {
      this.parentCont.removeChild(this.ptc);
    }

    // --------------------------------------------------------------
    // Update
    // --------------------------------------------------------------

  }, {
    key: 'lUp',
    value: function lUp(fallSpeed) {
      this.ptc.x += this.vX;
      this.ptc.y += this.vY * fallSpeed;

      if (this.ptc.y > this.MAX_Y) {
        this.remove();
        return false;
      }
      return true;
    }
  }]);

  return TownSnowParticle;
}();

exports.default = TownSnowParticle;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfoBubble = function (_PIXI$Container) {
  _inherits(InfoBubble, _PIXI$Container);

  function InfoBubble() {
    _classCallCheck(this, InfoBubble);

    // const
    var _this = _possibleConstructorReturn(this, (InfoBubble.__proto__ || Object.getPrototypeOf(InfoBubble)).call(this));

    _this.LIMIT_X = 190;
    _this.LIMIT_Y_TOP = 180;
    _this.LIMIT_Y_BTM = 210;

    // vars
    _this.isVisible = false;
    _this.isOpen = false;
    _this.tempHitData = {
      hR: 250
    };

    // app
    _this.isApp = false;
    _this.appLink = '';

    // centering
    _this.tempDiff = 0;
    _this.tempDateH = 0;
    _this.tempBtnH = 0;
    _this.tempPad = 0;

    _this.startStyles = [{ font: '20px ' + _ConfigScene2.default.FONT_BASE, fill: '#407c85' }, { font: '20px ' + _ConfigScene2.default.FONT_BASE, fill: '#134d54' }, { font: '15px ' + _ConfigScene2.default.FONT_BASE, fill: '#ffffff' }];

    _this.actualId = -1; // actual open id
    _this.infoData = null; // actual info data
    _this.acData = null; // temp activity data data

    // parts
    _this.closeBg = null;
    _this.mainBg = null;

    _this.titleDate = null;
    _this.titleTx1 = null;
    _this.titleTx2 = null;

    _this.startBtnTx = null;
    _this.startBtn = null;
    _this.startBtnBg = null;
    _this.startBtnFld = null;

    _this.closeBtnTx = null;
    _this.closeBtn = null;

    // init
    _this.init();
    return _this;
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(InfoBubble, [{
    key: 'init',
    value: function init() {
      // props
      this.visible = false;

      // parts
      this.setParts();

      // lsns
      aScene.signals.infoCall.add(this.infoCallFc, this);
    }

    // --------------------------------------------------------------
    // OverCheck
    // --------------------------------------------------------------

    // to prevent hover state on items under bubble

  }, {
    key: 'overCheck',
    value: function overCheck() {
      if (aPage.features.isTouch) {
        return this.isVisible; // prevent double item select on touch
      }
      return this.isVisible && aScene.collisionHelper.hitCircle(this.position, this.tempHitData, false);
    }

    // --------------------------------------------------------------
    // Set parts
    // --------------------------------------------------------------

  }, {
    key: 'setParts',
    value: function setParts() {
      this.closeBg = new PIXI.Container();
      this.addChild(this.closeBg);
      this.closeBg.interactive = true;
      this.closeBg.on('pointerup', function () {
        aScene.signals.infoCall.dispatch(_ConfigScene2.default.E_INFO_BLL_HIDE);
      });

      this.setMainBg();

      // titles
      this.setTitleDate();
      this.setTitleTx1();
      this.setTitleTx2();

      // buttons
      this.setCloseBtn();
      this.setStartBtn();
    }
  }, {
    key: 'setMainBg',
    value: function setMainBg() {
      this.mainBg = new PIXI.Sprite.fromFrame('win-info-bg.png');
      this.addChild(this.mainBg);
      this.mainBg.anchor.x = 0.5;
      this.mainBg.anchor.y = 0.5;
      this.mainBg.interactive = true; // to prevent clicking on items underneath
    }
  }, {
    key: 'resetCloseBg',
    value: function resetCloseBg() {
      this.closeBg.hitArea = new PIXI.Rectangle(-this.x, -this.y, aPage.resizer.canvasW, aPage.resizer.canvasH);
    }

    // --------------------------------------------------------------
    // Title - date
    // --------------------------------------------------------------

  }, {
    key: 'setTitleDate',
    value: function setTitleDate() {
      this.titleDate = new PIXI.Text('', {
        font: '18px ' + _ConfigScene2.default.FONT_BASE,
        fill: '#ffffff'
      });
      this.titleDate.y = -90;
      this.addChild(this.titleDate);
    }
  }, {
    key: 'updateTitleDate',
    value: function updateTitleDate(dateNum) {
      this.titleDate.text = dateNum + '. prosince';
      this.titleDate.updateText();
      this.titleDate.x = -Math.round(this.titleDate.width * 0.5);
    }

    // --------------------------------------------------------------
    // Title - Tx 1
    // --------------------------------------------------------------

  }, {
    key: 'setTitleTx1',
    value: function setTitleTx1() {
      this.titleTx1 = new PIXI.Text('', {
        font: '28px ' + _ConfigScene2.default.FONT_BASE,
        fill: '#ffffff',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 220
      });
      this.addChild(this.titleTx1);
    }
  }, {
    key: 'updateTitleTx1',
    value: function updateTitleTx1(txt) {
      this.titleTx1.text = txt;
      this.titleTx1.updateText();
      this.titleTx1.x = -Math.round(this.titleTx1.width * 0.5);
    }

    // --------------------------------------------------------------
    // Title - Tx 2
    // --------------------------------------------------------------

  }, {
    key: 'setTitleTx2',
    value: function setTitleTx2() {
      this.titleTx2 = new PIXI.Text('', {
        font: '18px ' + _ConfigScene2.default.FONT_BASE,
        fill: '#ffffff',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 200
      });
      this.addChild(this.titleTx2);
    }
  }, {
    key: 'updateTitleTx2',
    value: function updateTitleTx2(txt) {
      this.titleTx2.text = txt;
      this.titleTx2.updateText();
      this.titleTx2.x = -Math.round(this.titleTx2.width * 0.5);
    }

    // --------------------------------------------------------------
    // Start btn
    // --------------------------------------------------------------

  }, {
    key: 'setStartBtn',
    value: function setStartBtn() {
      var _this2 = this;

      // container
      this.startBtn = new PIXI.Container();
      this.addChild(this.startBtn);

      // bg
      this.startBtnTx = [PIXI.Texture.fromImage('win-info-btn-play-normal.png'), PIXI.Texture.fromImage('win-info-btn-play-hover.png'), PIXI.Texture.fromImage('win-info-btn-locked.png')];

      this.startBtnBg = new PIXI.Sprite(this.startBtnTx[0]);
      this.startBtnBg.anchor.x = 0.5;
      this.startBtnBg.anchor.y = 0.5;
      this.startBtn.addChild(this.startBtnBg);

      // tx
      this.startBtnFld = new PIXI.Text('', this.startStyles[0]);
      this.startBtn.addChild(this.startBtnFld);

      // events
      this.startBtn.interactive = true;
      this.startBtn.buttonMode = true;
      this.startBtn.on('pointerup', function () {
        _this2.startActivity();
        aScene.signals.infoCall.dispatch(_ConfigScene2.default.E_INFO_BLL_HIDE);
      });
      this.startBtn.on('pointerover', function () {
        _this2.startBtnFld.style = _this2.startStyles[1];
        _this2.startBtnBg.texture = _this2.startBtnTx[1];
      });
      this.startBtn.on('pointerout', function () {
        _this2.startBtnFld.style = _this2.startStyles[0];
        _this2.startBtnBg.texture = _this2.startBtnTx[0];
      });
    }
  }, {
    key: 'updateStartBtn',
    value: function updateStartBtn(title) {
      this.checkStoreLinks();
      if (this.isApp) {
        this.startBtnFld.visible = false;
        this.startBtn.alpha = this.appLink.length > 0 ? 1 : 0.3;
      } else {
        this.startBtnFld.visible = true;
        this.startBtn.alpha = 1;
      }
      this.startBtn.interactive = this.isOpen;
      this.startBtn.buttonMode = this.isOpen;
      if (this.isOpen) {
        this.startBtn.y = 70;
        this.startBtnBg.texture = this.startBtnTx[0];
        this.startBtnFld.style = this.startStyles[0];
        this.startBtnFld.text = title;
      } else {
        this.startBtn.y = 62;
        this.startBtnBg.texture = this.startBtnTx[2];
        this.startBtnFld.style = this.startStyles[2];
        this.startBtnFld.text = this.getUnlockString();
      }
      // center text
      this.startBtnFld.updateText();
      this.startBtnFld.x = -Math.round(this.startBtnFld.width * 0.5);
      this.startBtnFld.y = -Math.round(this.startBtnFld.height * 0.5);
    }
  }, {
    key: 'startActivity',
    value: function startActivity() {
      if (this.isApp) {
        if (this.appLink.length > 0) {
          window.open(this.appLink, '_blank');
        }
      } else if (aPage.features.isAppOpen(aScene.daysInfoArr[this.actualId])) {
        window.location.hash = aScene.daysInfoArr[this.actualId].linkHash;
      } else {
        window.location.hash = aScene.daysInfoArr[this.actualId].alt.linkHash;
      }
    }
  }, {
    key: 'checkStoreLinks',
    value: function checkStoreLinks() {
      if (aPage.features.isMobile && this.infoData.appLinks) {
        this.isApp = true;
        if (aPage.features.isIOS) {
          this.appLink = this.infoData.appLinks.ios;
          this.startBtnTx = [PIXI.Texture.fromImage('win-info-store-ios.png'), PIXI.Texture.fromImage('win-info-store-ios.png'), PIXI.Texture.fromImage('win-info-btn-locked.png')];
        } else {
          this.appLink = this.infoData.appLinks.play;
          this.startBtnTx = [PIXI.Texture.fromImage('win-info-store-android.png'), PIXI.Texture.fromImage('win-info-store-android.png'), PIXI.Texture.fromImage('win-info-btn-locked.png')];
        }
      } else if (this.isApp) {
        // reset back
        this.isApp = false;
        this.startBtnTx = [PIXI.Texture.fromImage('win-info-btn-play-normal.png'), PIXI.Texture.fromImage('win-info-btn-play-hover.png'), PIXI.Texture.fromImage('win-info-btn-locked.png')];
      }
    }
  }, {
    key: 'getUnlockString',
    value: function getUnlockString() {
      var dateDiff = 1 + this.actualId - actionUuids.length;
      var dayLabel = '';
      if (dateDiff === 1) {
        dayLabel = 'den';
      } else if (dateDiff < 5) {
        dayLabel = 'dny';
      } else {
        dayLabel = 'dní';
      }
      return 'Odemkne se za ' + dateDiff + ' ' + dayLabel;
    }

    // --------------------------------------------------------------
    // Set btn close
    // --------------------------------------------------------------

  }, {
    key: 'setCloseBtn',
    value: function setCloseBtn() {
      var _this3 = this;

      this.closeBtnTx = [PIXI.Texture.fromImage('win-info-btn-close-normal.png'), PIXI.Texture.fromImage('win-info-btn-close-hover.png')];

      this.closeBtn = new PIXI.Sprite(this.closeBtnTx[0]);
      this.closeBtn.x = 69;
      this.closeBtn.y = -113;
      this.addChild(this.closeBtn);

      this.closeBtn.interactive = true;
      this.closeBtn.buttonMode = true;
      this.closeBtn.on('pointerup', function () {
        aScene.signals.infoCall.dispatch(_ConfigScene2.default.E_INFO_BLL_HIDE);
      });
      this.closeBtn.on('pointerover', function () {
        _this3.closeBtn.texture = _this3.closeBtnTx[1];
      });
      this.closeBtn.on('pointerout', function () {
        _this3.closeBtn.texture = _this3.closeBtnTx[0];
      });
    }

    // --------------------------------------------------------------
    // Lsn
    // --------------------------------------------------------------

  }, {
    key: 'infoCallFc',
    value: function infoCallFc(sgType, optParams) {
      switch (sgType) {
        case _ConfigScene2.default.E_INFO_BLL_SHOW:
          if (this.actualId !== optParams[0]) {
            // update id
            this.actualId = optParams[0];
            // set position
            this.setPosition(optParams[1]);
            // update
            this.updateContent();
            // show
            this.showBll(true);
            // stats
            aPage.stats.trackEvent('Open-Info', this.actualId);
          }
          break;
        case _ConfigScene2.default.E_INFO_BLL_HIDE:
          if (this.actualId !== -1) {
            this.actualId = -1;
            this.showBll(false);
          }
          break;
        default:
      }
    }
  }, {
    key: 'setPosition',
    value: function setPosition(posPoint) {
      this.x = posPoint.x;
      this.y = posPoint.y;

      // limits
      if (this.x < this.LIMIT_X) {
        this.x = this.LIMIT_X;
      } else if (this.x > aPage.resizer.canvasW - this.LIMIT_X) {
        this.x = aPage.resizer.canvasW - this.LIMIT_X;
      }

      if (this.y < this.LIMIT_Y_TOP) {
        this.y = this.LIMIT_Y_TOP;
      } else if (this.y > aPage.resizer.canvasH - this.LIMIT_Y_BTM) {
        this.y = aPage.resizer.canvasH - this.LIMIT_Y_BTM;
      }

      // round
      this.x = Math.round(this.x);
      this.y = Math.round(this.y);
    }

    // --------------------------------------------------------------
    // Show/Hide
    // --------------------------------------------------------------

  }, {
    key: 'showBll',
    value: function showBll(doShow) {
      TweenMax.killTweensOf(this);
      TweenMax.killTweensOf(this.scale);
      if (doShow) {
        this.isVisible = true;
        // show
        this.resetCloseBg();
        this.visible = true;
        this.alpha = 0.0;
        this.scale.x = 0.5;
        this.scale.y = 0.5;
        TweenMax.to(this, 0.4, { alpha: 1.0, ease: Sine.easeOut });
        TweenMax.to(this.scale, 0.4, { x: 1.0, y: 1.0, ease: Back.easeOut });
      } else {
        this.isVisible = false;
        // hide
        TweenMax.to(this, 0.3, { alpha: 0.0, onComplete: this.hideComplete, onCompleteScope: this });
        TweenMax.to(this.scale, 0.3, { x: 0.4, y: 0.4, ease: Sine.easeIn });
      }
    }
  }, {
    key: 'hideComplete',
    value: function hideComplete() {
      this.visible = false;
    }
  }, {
    key: 'updateContent',
    value: function updateContent() {
      this.infoData = aScene.daysInfoArr[this.actualId];
      if (!aPage.features.isAppOpen(this.infoData)) {
        this.infoData = this.infoData.alt;
      }

      this.isOpen = this.actualId < actionUuids.length;

      this.updateTitleDate(this.actualId + 1);
      this.updateTitleTx1(this.infoData.title1);
      this.updateTitleTx2(this.infoData.title2);
      this.updateStartBtn(this.infoData.sLabel);

      // set positions
      this.tempDateH = this.titleDate.height / 2;
      this.tempBtnH = this.startBtn.height / 2;
      this.tempDiff = this.startBtn.y - this.titleDate.y - this.tempDateH - this.tempBtnH;

      if (this.titleTx2.text.length < 2) {
        this.titleTx1.y = Math.round(this.titleDate.y + this.tempDateH + this.tempDiff * 0.5 - this.titleTx1.height * 0.5);
      } else {
        this.tempPad = (this.tempDiff - this.titleTx1.height - this.titleTx2.height) / 5;
        this.titleTx1.y = Math.round(this.titleDate.y + this.tempDateH + this.tempPad * 2);
        this.titleTx2.y = Math.round(this.titleTx1.y + this.titleTx1.height + this.tempPad);
      }
    }
  }]);

  return InfoBubble;
}(PIXI.Container);

exports.default = InfoBubble;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Events = __webpack_require__(1);

var _ConfigScene = __webpack_require__(0);

var _ConfigScene2 = _interopRequireDefault(_ConfigScene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SceneManager = function () {
  function SceneManager() {
    _classCallCheck(this, SceneManager);

    // const
    this.OFFSETS = {
      HEAVEN: 0,
      TOWN: _ConfigScene2.default.SIZES.SCENE_ACTIVE_HEIGHT - _ConfigScene2.default.SIZES.SCENE_CONT_HEIGHT
    };
    this.ANIM = {
      TIMES: {
        MAIN: 5.5,
        SCALE_IN: 3.7,
        SCALE_OUT: 3.0
      }
    };
    this.GOD_SNOW_LIMIT = 0.8;

    // vars - base
    this.msFrame = 0;

    // snow
    this.snowMain = 0; // 0-1 - main intensity
    this.snowAngels = [];

    // god
    this.godShown = false;
    this.godResetTimer = null;

    // vars - transition
    this.sceneState = 0; // 0 - town, 1-heaven, -1-transition
    this.sceneDestination = 0; // 0 - town, 1-heaven - for ambi sound
    this.offset = this.OFFSETS.TOWN;
    this.offsetProgress = -1; // -1 - 1
    this.townScale = 0;
    this.firstTransition = true; // for swap sfx

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  _createClass(SceneManager, [{
    key: 'init',
    value: function init() {
      // listeners
      aScene.signals.sceneCallMain.add(this.callMainFc, this);
    }

    // --------------------------------------------------------------
    // Main Call
    // --------------------------------------------------------------

  }, {
    key: 'callMainFc',
    value: function callMainFc(sgType) {
      switch (sgType) {
        case _Events.EVENTS.MOVE_TO_HEAVEN_START:
          this.moveToHeaven();
          // try reset god
          clearTimeout(this.godResetTimer);
          this.godShown = false;
          break;
        case _Events.EVENTS.MOVE_TO_TOWN_START:
          this.moveToTown();
          break;
        default:
      }
    }

    // --------------------------------------------------------------
    // Snow
    // --------------------------------------------------------------

  }, {
    key: 'snowUpdate',
    value: function snowUpdate() {
      var _this = this;

      this.snowMain = this.snowAngels.reduce(function (a, b) {
        return a + b;
      }) / this.snowAngels.length;
      if (this.snowMain > this.GOD_SNOW_LIMIT && !this.godShown) {
        this.godShown = true;
        aScene.sndManager.playItemSfx('god');
        aScene.signals.sceneCallMain.dispatch(_Events.EVENTS.SHOW_GOD, 4700);
        this.godResetTimer = setTimeout(function () {
          _this.godShown = false;
        }, 10000);
        aPage.stats.trackEvent('Snow Max');
      }
    }

    // --------------------------------------------------------------
    // Move - Up
    // --------------------------------------------------------------

  }, {
    key: 'moveToHeaven',
    value: function moveToHeaven() {
      this.sceneState = -1;
      this.sceneDestination = 1;
      TweenMax.killTweensOf(this);
      TweenMax.to(this, this.ANIM.TIMES.MAIN, {
        offset: this.OFFSETS.HEAVEN,
        ease: Power3.easeInOut,
        onUpdate: this.moveUpdate,
        onUpdateScope: this,
        onComplete: this.moveToHeavenEnd,
        onCompleteScope: this
      });
      TweenMax.to(this, this.ANIM.TIMES.SCALE_IN, {
        townScale: 1,
        ease: Power2.easeInOut
      });
      aScene.sndManager.playSfx(this.firstTransition ? 'transition-1' : 'transition-1-no-music');
    }
  }, {
    key: 'moveToHeavenEnd',
    value: function moveToHeavenEnd() {
      this.sceneState = 1;
      aScene.signals.sceneCallMain.dispatch(_Events.EVENTS.MOVE_TO_HEAVEN_END);
    }

    // --------------------------------------------------------------
    // Move - Down
    // --------------------------------------------------------------

  }, {
    key: 'moveToTown',
    value: function moveToTown() {
      this.sceneState = -1;
      this.sceneDestination = 0;
      TweenMax.killTweensOf(this);
      TweenMax.to(this, this.ANIM.TIMES.MAIN, {
        offset: this.OFFSETS.TOWN,
        ease: Power3.easeInOut,
        onUpdate: this.moveUpdate,
        onUpdateScope: this,
        onComplete: this.moveToTownEnd,
        onCompleteScope: this
      });
      TweenMax.to(this, this.ANIM.TIMES.SCALE_OUT, {
        townScale: 0,
        delay: this.ANIM.TIMES.MAIN - this.ANIM.TIMES.SCALE_OUT,
        ease: Power2.easeOut
      });
      aScene.sndManager.playSfx(this.firstTransition ? 'transition-0' : 'transition-0-no-music');
    }
  }, {
    key: 'moveToTownEnd',
    value: function moveToTownEnd() {
      this.firstTransition = false;
      this.sceneState = 0;
      aScene.signals.sceneCallMain.dispatch(_Events.EVENTS.MOVE_TO_TOWN_END);
    }

    // --------------------------------------------------------------
    // Move - Shared
    // --------------------------------------------------------------

  }, {
    key: 'moveUpdate',
    value: function moveUpdate() {
      this.offsetProgress = (0.5 - this.offset / this.OFFSETS.TOWN) * 2;
    }
  }]);

  return SceneManager;
}();

exports.default = SceneManager;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// scene.js